// 安全的翻译访问器 - 防止访问不存在的键时出错
export const getSafeTranslator = (lang, defaultLang = 'en') => {
    const targetLang = languages[lang] || languages[defaultLang]
    const defaultLangData = languages[defaultLang]
    
    // 创建一个代理，安全地访问翻译
    const createProxy = (obj, defaultObj) => {
        return new Proxy(obj || {}, {
            get: (target, key) => {
                if (typeof target[key] === 'object' && target[key] !== null) {
                    return createProxy(target[key], defaultObj && defaultObj[key])
                }
                return target[key] || (defaultObj && defaultObj[key]) || ''
            }
        })
    }
    
    return createProxy(targetLang, defaultLangData)
}

export const languages = {
    en: {
        nav: {
            home: 'Home',
            solutions: 'Solutions',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistics',
            products: 'Products',
            platform: 'Platform',
            pricing: 'Pricing',
            faq: 'FAQ',
            about: 'About Us',
            contact: 'Contact Us',
            getStarted: 'Get Started',
            resources: 'Resources'
        },
        megamenu: {
            solByType: 'By Type',
            solPopular: 'Popular',
            solMostPopular: 'Most Popular',
            solBrandedPackaging: 'Branded Packaging',
            solBrandedPackagingDesc: 'Custom packaging, inserts and unboxing experience',
            solExplore: 'Explore',
            solNew: 'New',
            solAPI: 'API Integration',
            solAPIDesc: 'Full API access for seamless integration',
            solLearnMore: 'Learn More',
            platCoreFeatures: 'Core Features',
            platOrderMgmt: 'Order Management',
            platInventory: 'Inventory Control',
            platInventoryDesc: 'Real-time inventory tracking and alerts',
            platQC: 'Quality Control',
            platQCDesc: 'Multi-step inspection process',
            platAnalytics: 'Analytics & Reports',
            platAnalyticsDesc: 'Comprehensive performance analytics',
            platIntegrations: 'Integrations',
            platShopify: 'Shopify',
            platShopifyDesc: 'Seamless Shopify store integration',
            platTikTokDesc: 'TikTok Shop fulfillment integration',
            platWoo: 'WooCommerce',
            platWooDesc: 'WooCommerce integration support',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: 'Technology',
            platREST: 'REST API',
            platRESTDesc: 'Full RESTful API for custom development',
            platWebhooksDesc: 'Real-time webhook notifications',
            platSecurity: 'Security',
            platSecurityDesc: 'Enterprise-grade security measures',
            platTracking: 'Tracking',
            platTrackingDesc: 'Real-time package tracking',
            resHelpCenter: 'Help Center',
            resGuides: 'Guides',
            resGuidesDesc: 'Detailed setup and optimization guides',
            resVideoDemos: 'Video Demos',
            resVideoDemosDesc: 'Visual tutorials and walkthroughs',
            resInsights: 'Insights',
            resBlog: 'Blog',
            resCaseStudies: 'Case Studies',
            resCaseStudiesDesc: 'Real success stories from our clients',
            resEbooks: 'Ebooks',
            resEbooksDesc: 'In-depth industry reports and guides',
            resDevelopers: 'Developers',
            resAPIDocs: 'API Docs',
            resAPIDocsDesc: 'Complete API documentation',
            resIntegration: 'Integration',
            resIntegrationDesc: 'Integration guides and tools',
            resStatus: 'Status',
            compAbout: 'About Us',
            compTeam: 'Our Team',
            compTeamDesc: 'Meet our expert team members',
            compCareers: 'Careers',
            compCareersDesc: 'Join our growing team',
            compContactDesc: 'Get in touch with us'
        },
        hero: {
            title1: 'China Supply Chain Partner for',
            title2: 'Cross-Border Ecommerce Brands',
            description: 'From sourcing and quality control to warehousing, fulfillment, and global shipping, FULFILLDROP helps fast-growing sellers run stable operations and scale with confidence.',
            btn: 'Talk to FULFILLDROP',
            trust1: 'Sourcing + Fulfillment + Shipping',
            trust2: 'Built for 10-10000+ orders/day',
            trust3: 'Transparent SLA & exception handling'
        },
        capabilities: {
            title: 'What We Help You Fix',
            items: [
                { number: '01', title: 'Supplier Stability', description: 'Build backup-ready supply with vetted factories, replacement options, and replenishment planning.' },
                { number: '02', title: 'Order Processing Efficiency', description: 'Automate order sync and fulfillment workflows to reduce manual errors and speed up dispatch.' },
                { number: '03', title: 'Quality & Consistency', description: 'Use clear QC checkpoints and exception handling to protect customer experience at scale.' },
                { number: '04', title: 'Customization Delivery', description: 'Run POD/OEM/ODM projects with repeatable sampling-to-production and packaging execution.' },
                { number: '05', title: 'Global Shipping Reliability', description: 'Leverage stable lanes and tracking visibility to keep delivery performance predictable.' },
                { number: '06', title: 'After-Sales Control', description: 'Standardize reship/refund workflows so service quality remains consistent during growth.' }
            ]
        },
        supplyChain: {
            title: 'One-Stop China Supply Chain Solutions',
            subtitle: 'A practical operating model used by fast-growing sellers',
            items: [
                { title: 'Category-Aware Execution', description: 'Built around the variables that break at scale: variants, damage, batch consistency, and risk handling' },
                { title: 'Supply Stability', description: 'Factory coordination, replenishment planning, and substitution matching to keep execution stable when demand spikes' },
                { title: 'Customization Execution', description: 'Sampling-to-production workflows plus packaging/inserts—executed consistently inside fulfillment' },
                { title: 'Controlled Fulfillment', description: 'Verified pick-pack-ship workflows with clear ownership—so scale doesn\'t increase errors' },
                { title: 'Visibility & Exceptions', description: 'Order sync, inventory visibility, tracking pushback, and structured after-sales rules' }
            ]
        },
        businessModels: {
            title: 'Solutions Tailored to Your Business Model',
            subtitle: 'Pick the model that matches your stage, margin target, and fulfillment complexity',
            items: [
                { title: 'Dropshipping Solutions', description: 'Stable Supply + Scalable Execution Ensure consistent supply and high-speed execution to support your winning products and aggressive advertising pace.' },
                { title: 'DTC Brand Solutions', description: 'End-to-End Brand Consistency Maintain a premium brand experience from production to delivery, ensuring quality never falters even as you scale globally.' },
                { title: 'E-commerce Fulfillment Solutions', description: 'Systematic Framework for High-Volume Orders Precision-engineered fulfillment for high-order velocity: Unmatched accuracy, peak efficiency, and predictable cost control.' },
                { title: '3PL / Inventory-Heavy Solutions', description: 'Accountability & Multi-Channel Control Gain full visibility into inventory, costs, and operational accountability. Perfectly adapted for multi-warehouse and multi-channel logistics.' },
                { title: 'POD / Customization Solutions', description: 'Replicable Systems for Bespoke Scale A robust framework for custom production and delivery. We don\'t just "make it"—we build a system that scales with your growth.' }
            ]
        },
        operatingSystem: {
            title: 'Built on a Unified Supply Chain Operating System',
            subtitle: 'From supplier to customer delivery, each module is measured by speed, quality, and cost control',
            items: [
                { title: 'Supply Resilience & Stability', description: 'Keep best-selling products in stock with reliable sourcing, fast replenishment, and substitute options.', highlight: '28-person sourcing team · 1.7M+ SKUs' },
                { title: 'Scalable Customization', description: 'Run POD / OEM / ODM with sampling-to-production support and consistent packaging execution.', highlight: 'POD / OEM / ODM · Logos, inserts & outer boxes' },
                { title: 'Integrated Warehousing & Inventory Control', description: 'Control inventory and 3PL execution with SKU discipline, consolidation, and multi-channel readiness.', highlight: 'Stocking + 3PL · Shopify / Yampi / Nuvemshop' },
                { title: 'High-Throughput Global Logistics', description: 'Deliver predictably with dedicated routes, customs support, and real-time tracking.', highlight: '98% of orders dispatched within 24h · Brazil, US & EU lanes' },
                { title: 'Quality Assurance & Exception Management', description: 'Prevent avoidable issues before shipment with QC checks and clear exception ownership.', highlight: 'Pre-shipment QC · Damage/Loss/Exception handling' },
                { title: 'After-Sales Support', description: 'Resolve after-sales with standardized workflows and improve execution through data feedback.', highlight: 'Multi-language support · Reship/Refund SOPs' }
            ]
        },
        whoUses: {
            title: 'Who Uses FULFILLDROP?',
            subtitle: 'We help ecommerce store owners scale their dropshipping business to global brand D2C stores',
            items: [
                { icon: 'briefcase', title: 'Dropshipping Entrepreneurs', description: 'Entrepreneurs have 99 problems, fulfillment shouldn\'t be one of them. With automatic inventory tracking and seamless order processing, FULFILLDROP keeps your operations running smoothly!' },
                { icon: 'users', title: 'Social Media Influencers', description: 'Influencers are powerful marketing assets for many ecommerce brands. FULFILLDROP prioritizes quality control and customer satisfaction, giving influencers confidence when promoting products we fulfill.' },
                { icon: 'chart-line', title: 'Ecommerce Professionals', description: 'Ecommerce professionals rely on streamlined, efficient systems to keep their businesses running smoothly. FULFILLDROP\'s ERP integrates with major platforms to automate and simplify the entire order processing workflow.' }
            ]
        },
        caseStudy: {
            title: 'Case Studies',
            subtitle: 'Real cases: How FULFILLDROP helps sellers achieve explosive business growth',
            badge: 'Success Case',
            caseTitle: 'Warren\'s Business Growth Story',
            intro: 'Warren is a dropshipping entrepreneur focused on home products. Through collaboration with FULFILLDROP, he achieved a 6x growth in order volume from 3,000 to 18,000 in less than a year, significantly expanding his business scale.',
            factors: { title: 'Key Success Factors:', items: ['Using AI-driven product research tools to discover high-potential products', 'Obtaining the most competitive prices through the global supply chain network', '48-hour fast procurement to ensure timely restocking and avoid stockouts', '5-12 day global delivery to improve customer satisfaction', 'Brand customization services to enhance customer loyalty', 'Automated order processing and inventory management to save operational time'] },
            results: { title: 'Results:', items: [{ number: '6x', label: 'Business Scale Expansion' }, { number: '40%', label: 'Customer Satisfaction Improvement' }, { number: '30%', label: 'Operating Cost Reduction' }] },
            btn: 'View Complete Case'
        },
        contact: {
            title: 'Get In Touch',
            subtitle: 'Have questions about FULFILLDROP? Fill out the form below and our team will get back to you within 24 hours.',
            form: { title: 'Contact Us', text1: 'Questions about FULFILLDROP? Check out our FAQ for answers to our most common questions.', text2: 'Still need help? We\'re here for you! Contact us below to learn more!', name: 'Name', email: 'Email Address', phone: 'Phone', message: 'Message', placeholder: { name: 'Enter your name', email: 'Enter your email', phone: 'Enter your phone number', message: 'Briefly describe your business needs' }, btn: 'Submit' },
            info: { title: 'Contact Information', items: [{ icon: 'phone', text: '+86 18905051115' }, { icon: 'whatsapp', text: 'WhatsApp: 0086 18905051115' }, { icon: 'envelope', text: '270302301@qq.com' }, { icon: 'envelope', text: 'colin270302301@gmail.com' }] }
        },
        partners: { title: 'Global Partners', subtitle: 'Trusted ecommerce and logistics platforms we work with for daily operations' },
        home: {
            trusted: 'Trusted by 100+ Cross-Border Sellers',
            operationsLive: 'Operations Live',
            dispatch24h: 'Orders dispatched within 24h',
            skuAvailable: 'SKUs Available to Source',
            integratedWith: 'Integrated with',
            statsQuote: 'Numbers tell the real story — we operate at scale.',
            whyChoose: 'Why Choose FULFILLDROP',
            whySubtitle: 'Built for operations that scale',
            whyDesc: 'We don\'t wait for issues to appear. We build systems that prevent them.',
            why1Title: 'Proactive Quality Control',
            why1Desc: 'We identify and resolve issues before they impact your customers. Multi-point QC, pre-shipment checks, and damage prevention are built into every order.',
            why2Title: 'Synchronized Communication',
            why2Desc: 'No more guessing. Get real-time updates on sourcing, production, and shipping — all in one view. Your customers get accurate info, faster.',
            why3Title: 'Custom Flexibility',
            why3Desc: 'POD, OEM, ODM — we handle custom packaging, inserts, and branding so your unboxing experience matches your brand promise.',
            industryTitle: 'Deep Specialization in Key Categories',
            industrySubtitle: 'We understand the unique challenges of each category — and have built targeted solutions.',
            industry1Title: 'Fashion & Apparel',
            industry1Desc: 'Size variants, fabric QC, and custom labeling — we handle the complexity of fashion fulfillment with precision.',
            industry2Title: 'Health Supplements',
            industry2Desc: 'Batch tracking, compliance documentation, and certified storage — built for supplement safety and trust.',
            industry3Title: 'Lighting & Home Decor',
            industry3Desc: 'Fragile handling protocols, insurance coverage, and protective packaging — your products arrive intact.',
            statsOrders: 'Daily Orders Processed',
            ctaPrimary: 'Talk to an Expert',
            ctaSecondary: 'Learn More About Our Platform',
            talkExpert: 'Talk to an Expert',
            viewAllSolutions: 'View All Solutions',
            explorePlatform: 'Explore the Platform',
            capEyebrow: 'Core Capabilities',
            solEyebrow: 'Solutions',
            solSubtitle: 'Pick the model that matches your stage and complexity'
        },
        faq: {
            title: 'Frequently Asked Questions',
            description: 'Find answers to common questions about our services',
            questions: 'Questions',
            contactTitle: 'Still Have Questions?',
            contactText: 'Our team is here to help you with any questions you may have',
            contactBtn: 'Contact Us',
            items: [
                {
                    category: 'Getting Started',
                    question: 'How do I get started with your fulfillment services?',
                    answer: 'Getting started is easy! Simply sign up for an account, connect your store, and send us your inventory. Our onboarding team will guide you through every step.'
                },
                {
                    category: 'Getting Started',
                    question: 'What are the minimum order requirements?',
                    answer: 'We have no minimum order requirements! Whether you ship 10 orders a day or 10,000, we can accommodate your needs.'
                },
                {
                    category: 'Getting Started',
                    question: 'How long does onboarding take?',
                    answer: 'Onboarding typically takes 3-5 business days, depending on your inventory complexity. We work diligently to get you up and running as quickly as possible.'
                },
                {
                    category: 'Pricing & Fees',
                    question: 'How are your pricing structured?',
                    answer: 'Our pricing is transparent and based on pick-pack-ship fees plus storage. We offer volume discounts for high-volume sellers. Contact us for a customized quote.'
                },
                {
                    category: 'Pricing & Fees',
                    question: 'Are there any hidden fees?',
                    answer: 'No hidden fees! All our charges are clearly outlined in your contract. We believe in transparent pricing so you can budget effectively.'
                },
                {
                    category: 'Pricing & Fees',
                    question: 'Do you offer volume discounts?',
                    answer: 'Yes! We offer tiered volume discounts that automatically apply as your order volume increases. The more you ship, the more you save.'
                },
                {
                    category: 'Inventory Management',
                    question: 'How do I send inventory to your warehouse?',
                    answer: 'We can coordinate with your suppliers directly, or you can ship inventory to our warehouse using any carrier. We provide detailed receiving instructions.'
                },
                {
                    category: 'Inventory Management',
                    question: 'Can I track my inventory in real-time?',
                    answer: 'Absolutely! Our dashboard provides real-time inventory tracking, including stock levels, incoming shipments, and order status.'
                },
                {
                    category: 'Inventory Management',
                    question: 'What happens if inventory runs low?',
                    answer: 'Our system automatically sends low-stock alerts, and our team will notify you proactively to ensure you never run out of popular items.'
                },
                {
                    category: 'Shipping & Delivery',
                    question: 'Which carriers do you work with?',
                    answer: 'We partner with all major carriers including FedEx, UPS, DHL, USPS, and regional carriers to ensure the best rates and delivery times.'
                },
                {
                    category: 'Shipping & Delivery',
                    question: 'Do you offer international shipping?',
                    answer: 'Yes! We ship to over 150 countries worldwide with optimized international shipping routes and customs clearance support.'
                },
                {
                    category: 'Shipping & Delivery',
                    question: 'What is your average delivery time?',
                    answer: 'Domestic orders typically deliver in 2-5 business days, while international orders take 5-14 business days depending on the destination.'
                },
                {
                    category: 'Returns & Exchanges',
                    question: 'How do returns work?',
                    answer: 'We handle returns on your behalf! Customers send returns to our warehouse, we inspect them, and update your inventory accordingly.'
                },
                {
                    category: 'Returns & Exchanges',
                    question: 'Can you handle exchanges?',
                    answer: 'Yes, we can manage the entire exchange process including inspection, restocking, and shipping replacement items to your customers.'
                },
                {
                    category: 'Returns & Exchanges',
                    question: 'What is your returns processing time?',
                    answer: 'Returns are typically processed within 24-48 hours of receipt, and your inventory is updated immediately in our system.'
                },
                {
                    category: 'Custom Solutions',
                    question: 'Can you handle custom packaging?',
                    answer: 'Absolutely! We offer custom packaging, branded inserts, gift wrapping, and special presentation services to elevate your brand.'
                },
                {
                    category: 'Custom Solutions',
                    question: 'Do you support kitting and assembly?',
                    answer: 'Yes! We provide kitting, assembly, bundling, and product customization services to create unique product combinations.'
                },
                {
                    category: 'Custom Solutions',
                    question: 'Can you integrate with my platform?',
                    answer: 'We integrate with all major ecommerce platforms including Shopify, WooCommerce, BigCommerce, Magento, and more. Contact us about custom integrations!'
                }
            ]
        },
        footer: {
            about: 'About Us',
            company: 'Company Profile',
            team: 'Team Members',
            news: 'News',
            careers: 'Join Us',
            solutions: 'Solutions',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistics',
            custom: 'Custom Solutions',
            support: 'Support',
            help: 'Help Center',
            faq: 'FAQ',
            contact: 'Contact Us',
            privacy: 'Privacy Policy',
            contactInfo: 'Contact Information',
            email: 'Email: 270302301@qq.com',
            phone: 'Phone: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 FULFILLDROP Cross-Border Ecommerce Platform. All rights reserved.'
        }
    },
    es: {
        nav: {
            home: 'Inicio',
            solutions: 'Soluciones',
            dropshipping: 'Dropshipping',
            fulfillment: 'Cumplimiento',
            logistics: 'Logística',
            products: 'Productos',
            platform: 'Plataforma',
            pricing: 'Precios',
            faq: 'FAQ',
            about: 'Sobre Nosotros',
            contact: 'Contacto',
            getStarted: 'Empezar',
            resources: 'Recursos'
        },
        megamenu: {
            solByType: 'Por Tipo',
            solPopular: 'Popular',
            solMostPopular: 'Más Popular',
            solBrandedPackaging: 'Embalaje Marcado',
            solBrandedPackagingDesc: 'Embalaje personalizado, insertos y experiencia de desempaque',
            solExplore: 'Explorar',
            solNew: 'Nuevo',
            solAPI: 'Integración API',
            solAPIDesc: 'Acceso API completo para integración perfecta',
            solLearnMore: 'Más Información',
            platCoreFeatures: 'Características Principales',
            platOrderMgmt: 'Gestión de Pedidos',
            platInventory: 'Control de Inventario',
            platInventoryDesc: 'Seguimiento y alertas de inventario en tiempo real',
            platQC: 'Control de Calidad',
            platQCDesc: 'Proceso de inspección de múltiples pasos',
            platAnalytics: 'Analíticas y Reportes',
            platAnalyticsDesc: 'Analíticas de rendimiento completas',
            platIntegrations: 'Integraciones',
            platShopify: 'Shopify',
            platShopifyDesc: 'Integración perfecta con Shopify',
            platTikTokDesc: 'Integración de cumplimiento con TikTok Shop',
            platWoo: 'WooCommerce',
            platWooDesc: 'Soporte de integración con WooCommerce',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: 'Tecnología',
            platREST: 'API REST',
            platRESTDesc: 'API RESTful completa para desarrollo personalizado',
            platWebhooksDesc: 'Notificaciones de webhook en tiempo real',
            platSecurity: 'Seguridad',
            platSecurityDesc: 'Medidas de seguridad de nivel empresarial',
            platTracking: 'Seguimiento',
            platTrackingDesc: 'Seguimiento de paquetes en tiempo real',
            resHelpCenter: 'Centro de Ayuda',
            resGuides: 'Guías',
            resGuidesDesc: 'Guías detalladas de configuración y optimización',
            resVideoDemos: 'Demostraciones en Video',
            resVideoDemosDesc: 'Tutoriales visuales y explicaciones',
            resInsights: 'Perspectivas',
            resBlog: 'Blog',
            resCaseStudies: 'Estudios de Caso',
            resCaseStudiesDesc: 'Historias de éxito reales de nuestros clientes',
            resEbooks: 'Ebooks',
            resEbooksDesc: 'Informes y guías detallados de la industria',
            resDevelopers: 'Desarrolladores',
            resAPIDocs: 'Docs API',
            resAPIDocsDesc: 'Documentación API completa',
            resIntegration: 'Integración',
            resIntegrationDesc: 'Guías y herramientas de integración',
            resStatus: 'Estado',
            compAbout: 'Sobre Nosotros',
            compTeam: 'Nuestro Equipo',
            compTeamDesc: 'Conozca a nuestros expertos',
            compCareers: 'Carreras',
            compCareersDesc: 'Únase a nuestro equipo en crecimiento',
            compContactDesc: 'Póngase en contacto con nosotros'
        },
        hero: {
            title1: 'Soluciones Integrales de Cadena de Suministro China:',
            title2: 'Adaptadas para Cada Etapa del Crecimiento del Vendedor',
            description: 'Desde la selección y adquisición de productos hasta el control de calidad, el cumplimiento global y la fabricación personalizada, empoderamos a los vendedores con entrega confiable, ejecución optimizada y crecimiento sostenible.',
            btn: 'Solicitar Presupuesto',
            trust1: 'Abastecimiento + Cumplimiento + Envío',
            trust2: 'Construido para 10-10000+ pedidos/día',
            trust3: 'SLA transparente y manejo de excepciones'
        },
        capabilities: {
            title: 'Nuestras Capacidades',
            items: [
                { number: '01', title: 'Haz que tu tienda sea única y atractiva', description: 'No importa dónde tengas tu tienda, en Shopify, WooCommerce, puedes crear tiendas personalizadas con el equipo de FULFILLDROP.' },
                { number: '02', title: 'Trabaja con proveedores estables', description: 'Para evitar los problemas de probar muchos proveedores para encontrar los mejores, FULFILLDROP selecciona proveedores confiables y calificados para ahorrarte tiempo y dinero.' },
                { number: '03', title: 'Procesa pedidos de tienda de manera efectiva', description: 'Ya sea que tu tienda tenga muchos pedidos o que acabe de abrirse, siempre es recomendable mejorar la eficiencia del trabajo para causar una buena impresión a tus clientes.' },
                { number: '04', title: 'Precios de productos con grandes márgenes', description: 'Vender en línea puede ser muy competitivo, los precios de tus productos pueden ser la clave para ganar clientes potenciales. Usa FULFILLDROP para garantizar beneficios y más ventas.' },
                { number: '05', title: 'Ofrece un servicio al cliente ejemplar', description: 'Además de un excelente servicio antes de la venta, el envío rápido y la notificación en tiempo oportuno del estado del pedido son factores importantes que aumentan el índice de retención de clientes.' },
                { number: '06', title: 'Mantente al tanto de las tendencias de la industria', description: 'Los dropshippers deben mantenerse al día sobre las últimas estrategias, trucos y tecnologías de dropshipping para aprovechar nuevas oportunidades.' }
            ]
        },
        supplyChain: {
            title: 'Soluciones Integrales de Cadena de Suministro China',
            subtitle: 'Construidas para una Ejecución Escalable',
            items: [
                { title: 'Ejecución Consciente de Categorías', description: 'Construido alrededor de las variables que se rompen a escala: variantes, daños, consistencia por lotes y manejo de riesgos' },
                { title: 'Estabilidad de Suministro', description: 'Coordinación de fábricas, planificación de reabastecimiento y coincidencia de sustituciones para mantener la ejecución estable cuando la demanda aumenta bruscamente' },
                { title: 'Ejecución de Personalización', description: 'Flujos de trabajo de muestreo a producción más empaque/inserciones: ejecutados de manera consistente dentro del cumplimiento' },
                { title: 'Cumplimiento Controlado', description: 'Flujos de trabajo verificados de selección, empaque y envío con propiedad clara: para que la escala no incremente los errores' },
                { title: 'Visibilidad y Excepciones', description: 'Sincronización de pedidos, visibilidad de inventario, retroalimentación de seguimiento y reglas estructuradas de posventa' }
            ]
        },
        businessModels: {
            title: 'Soluciones Adaptadas a Tu Modelo de Negocio',
            subtitle: 'Los diferentes vendedores priorizan diferentes Resultados Clave',
            items: [
                { title: 'Soluciones de Dropshipping', description: 'Suministro Estable + Ejecución Escalable Asegurar un suministro consistente y una ejecución de alta velocidad para apoyar tus productos ganadores y ritmo publicitario agresivo.' },
                { title: 'Soluciones de Marca DTC', description: 'Consistencia de Marca de Extrem a Extrem Mantener una experiencia de marca premium desde la producción hasta la entrega, asegurando que la calidad nunca decaiga incluso a medida que escales globalmente.' },
                { title: 'Soluciones de Cumplimiento de Comercio Electrónico', description: 'Marco Sistemático para Pedidos de Alto Volumen Cumplimiento diseñado con precisión para alta velocidad de pedidos: Precisión inigualable, eficiencia máxima y control de costos predecible.' },
                { title: 'Soluciones 3PL / con Mucho Inventario', description: 'Responsabilidad y Control Multi-Canal Obtener una visibilidad completa del inventario, costos y responsabilidad operativa. Perfectamente adaptado para logística multi-almacén y multi-canal.' },
                { title: 'Soluciones de POD / Personalización', description: 'Sistemas Replicables para Escala Bespoke Un marco robusto para producción personalizada y entrega. No solo "lo hacemos"—construimos un sistema que escala con tu crecimiento.' }
            ]
        },
        operatingSystem: {
            title: 'Construido en un Sistema Operativo de Cadena de Suministro Unificado',
            subtitle: 'Seis módulos core funcionan como un sistema integrado: construido para mantener la ejecución estable a medida que tu negocio escala',
            items: [
                { title: 'Resiliencia y Estabilidad de Suministro', description: 'Mantén los productos más vendidos en stock con suministro confiable, reabastecimiento rápido y opciones de sustitución.', highlight: 'Equipo de abastecimiento de 28 personas · 1.7M+ SKUs' },
                { title: 'Personalización Escalable', description: 'Ejecuta POD / OEM / ODM con soporte de muestreo a producción y ejecución consistente de empaque.', highlight: 'POD / OEM / ODM · Logos, insertions y cajas exteriores' },
                { title: 'Almacenamiento Integrado y Control de Inventario', description: 'Controla el inventario y la ejecución 3PL con disciplina SKU, consolidación y preparación multi-canal.', highlight: 'Almacenamiento + 3PL · Shopify / Yampi / Nuvemshop' },
                { title: 'Logística Global de Alto Rendimiento', description: 'Entrega de manera predecible con rutas dedicadas, apoyo aduanero y seguimiento en tiempo real.', highlight: '98% de los pedidos enviados dentro de 24h · Brasil, EE. UU. y vías de la UE' },
                { title: 'Garantía de Calidad y Manejo de Excepciones', description: 'Previene problemas evitables antes del envío con controles de QC y propiedad clara de excepciones.', highlight: 'QC previo al envío · Manejo de daños / pérdidas / excepciones' },
                { title: 'Soporte Postventa', description: 'Resuelve postventa con flujos de trabajo estandarizados y mejora la ejecución a través de retroalimentación de datos.', highlight: 'Soporte multilingual · Reenvío / Reembolso SOPs' }
            ]
        },
        whoUses: {
            title: '¿Quién usa FULFILLDROP?',
            subtitle: 'Ayudamos a los propietarios de tiendas de comercio electrónico a escalar su negocio de dropshipping a tiendas de marca global D2C',
            items: [
                { icon: 'briefcase', title: 'Empresarios de Dropshipping', description: 'Los emprendedores tienen 99 problemas, el cumplimiento no debería ser uno de ellos. Con seguimiento automático de inventario y procesamiento fluido de pedidos, FULFILLDROP mantiene tus operaciones funcionando sin problemas!' },
                { icon: 'users', title: 'Influencers de Redes Sociales', description: 'Los influyentes son activos de marketing poderosos para muchas marcas de comercio electrónico. FULFILLDROP prioriza el control de calidad y la satisfacción del cliente, brindando a los influyentes confianza al promover productos que cumplimos.' },
                { icon: 'chart-line', title: 'Profesionales de Comercio Electrónico', description: 'Los profesionales de comercio electrónico confían en sistemas eficientes y optimizados para mantener sus negocios funcionando sin problemas. El ERP de FULFILLDROP se integra con plataformas principales para automatizar y simplificar todo el flujo de procesamiento de pedidos.' }
            ]
        },
        caseStudy: {
            title: 'Estudios de Caso',
            subtitle: 'Casos reales: Cómo FULFILLDROP ayuda a los vendedores a lograr un crecimiento empresarial explosivo',
            badge: 'Caso de Éxito',
            caseTitle: 'La Historia de Crecimiento Empresarial de Warren',
            intro: 'Warren es un emprendedor de dropshipping especializado en productos para el hogar. A través de la colaboración con FULFILLDROP, logró un crecimiento de 6 veces en el volumen de pedidos de 3,000 a 18,000 en menos de un año, expandiendo significativamente la escala de su negocio.',
            factors: { title: 'Factores Clave de Éxito:', items: ['Uso de herramientas de investigación de productos impulsados por IA para descubrir productos de alto potencial', 'Obtención de los precios más competitivos a través de la red global de cadena de suministro', 'Adquisición rápida de 48 horas para garantizar el reabastecimiento oportuno y evitar faltas de stock', 'Entrega global de 5-12 días para mejorar la satisfacción del cliente', 'Servicios de personalización de marca para aumentar la fidelidad del cliente', 'Procesamiento automatizado de pedidos y gestión de inventario para ahorrar tiempo operativo'] },
            results: { title: 'Resultados:', items: [{ number: '6x', label: 'Expansión de la Escala Empresarial' }, { number: '40%', label: 'Mejora en la Satisfacción del Cliente' }, { number: '30%', label: 'Reducción de Costos Operativos' }] },
            btn: 'Ver Caso Completo'
        },
        contact: {
            title: 'Póngase en Contacto',
            subtitle: '¿Tienes preguntas sobre FULFILLDROP? Completa el formulario a continuación y nuestro equipo se comunicará contigo dentro de las 24 horas.',
            form: { title: 'Contáctanos', text1: '¿Preguntas sobre FULFILLDROP? Consulta nuestra sección de Preguntas Frecuentes para obtener respuestas a nuestras preguntas más comunes.', text2: '¿Todavía necesitas ayuda? ¡Estamos aquí para ti! Contáctanos a continuación para obtener más información.', name: 'Nombre', email: 'Correo Electrónico', phone: 'Teléfono', message: 'Mensaje', placeholder: { name: 'Ingresa tu nombre', email: 'Ingresa tu correo electrónico', phone: 'Ingresa tu número de teléfono', message: 'Describe brevemente tus necesidades empresariales' }, btn: 'Enviar' },
            info: { title: 'Información de Contacto', items: [{ icon: 'phone', text: '+86 18905051115' }, { icon: 'whatsapp', text: 'WhatsApp: 0086 18905051115' }, { icon: 'envelope', text: '270302301@qq.com' }, { icon: 'envelope', text: 'colin270302301@gmail.com' }] }
        },
        partners: { title: 'Socios Globales', subtitle: 'Nos asociamos con plataformas de comercio electrónico líderes y proveedores de servicios logísticos mundialmente para ofrecerte las mejores soluciones de comercio electrónico transfronterizo' },
        home: {
            trusted: 'Recomendado por 100+ Vendedores Cross-Border',
            operationsLive: 'Operaciones en Vivo',
            dispatch24h: 'Pedidos enviados en 24h',
            skuAvailable: 'SKUs Disponibles para Abastecer',
            integratedWith: 'Integrado con',
            statsQuote: 'Los números cuentan la historia real: operamos a escala.',
            whyChoose: 'Por Qué Elegir FULFILLDROP',
            whySubtitle: 'Construido para operaciones que escalan',
            whyDesc: 'No esperamos a que aparezcan los problemas. Construimos sistemas que los previenen.',
            why1Title: 'Control de Calidad Proactivo',
            why1Desc: 'Identificamos y resolvemos problemas antes de que impacten a sus clientes. QC multipunto, verificaciones pre-envío y prevención de daños integradas en cada pedido.',
            why2Title: 'Comunicación Sincronizada',
            why2Desc: 'No más adivinar. Obtenga actualizaciones en tiempo real sobre abastecimiento, producción y envío — todo en una sola vista. Sus clientes obtienen información precisa, más rápido.',
            why3Title: 'Flexibilidad Personalizada',
            why3Desc: 'POD, OEM, ODM — manejamos empaque personalizado, insertos y branding para que su experiencia de desempaque cumpla su promesa de marca.',
            industryTitle: 'Especialización Profunda en Categorías Clave',
            industrySubtitle: 'Entendemos los desafíos únicos de cada categoría y hemos construido soluciones dirigidas.',
            industry1Title: 'Moda y Ropa',
            industry1Desc: 'Variantes de talla, QC de tejidos y etiquetado personalizado — manejamos la complejidad del cumplimiento de moda con precisión.',
            industry2Title: 'Suplementos de Salud',
            industry2Desc: 'Seguimiento por lotes, documentación de cumplimiento y almacenamiento certificado — diseñado para la seguridad de suplementos.',
            industry3Title: 'Iluminación y Decoración del Hogar',
            industry3Desc: 'Protocolos de manejo de frágiles, cobertura de seguro y empaque protector — sus productos llegan intactos.',
            statsOrders: 'Pedidos Diarios Procesados',
            ctaPrimary: 'Hable con un Experto',
            ctaSecondary: 'Más Información Sobre Nuestra Plataforma',
            talkExpert: 'Hable con un Experto',
            viewAllSolutions: 'Ver Todas las Soluciones',
            explorePlatform: 'Explorar la Plataforma',
            capEyebrow: 'Capacidades Centrales',
            solEyebrow: 'Soluciones',
            solSubtitle: 'Elija el modelo que se adapte a su etapa y complejidad'
        },
        faq: {
            title: 'Preguntas Frecuentes',
            description: 'Encuentre respuestas a preguntas comunes sobre nuestros servicios',
            questions: 'Preguntas',
            contactTitle: '¿Todavía Tiene Preguntas?',
            contactText: 'Nuestro equipo está aquí para ayudarte con cualquier pregunta que puedas tener',
            contactBtn: 'Contáctanos',
            items: [
                {
                    category: 'Comenzar',
                    question: '¿Cómo empiezo con sus servicios de cumplimiento?',
                    answer: '¡Comenzar es fácil! Simplemente registra una cuenta, conecta tu tienda y envíanos tu inventario. Nuestro equipo de incorporación te guiará en cada paso.'
                },
                {
                    category: 'Comenzar',
                    question: '¿Cuáles son los requisitos mínimos de pedido?',
                    answer: '¡No tenemos requisitos mínimos de pedido! Ya sea que envíes 10 pedidos al día o 10,000, podemos adaptarnos a tus necesidades.'
                },
                {
                    category: 'Comenzar',
                    question: '¿Cuánto tiempo tarda la incorporación?',
                    answer: 'La incorporación normalmente tarda de 3 a 5 días hábiles, según la complejidad de tu inventario. Trabajamos diligentemente para ponerte en funcionamiento lo más rápido posible.'
                },
                {
                    category: 'Precios y Tarifas',
                    question: '¿Cómo está estructurado su precio?',
                    answer: 'Nuestros precios son transparentes y se basan en tarifas de recoger-empaquetar-enviar más almacenamiento. Ofrecemos descuentos por volumen para vendedores de alto volumen. Contáctanos para una cotización personalizada.'
                },
                {
                    category: 'Precios y Tarifas',
                    question: '¿Hay tarifas ocultas?',
                    answer: '¡Sin tarifas ocultas! Todos nuestros cargos se describen claramente en tu contrato. Creemos en precios transparentes para que puedas presupuestar efectivamente.'
                },
                {
                    category: 'Precios y Tarifas',
                    question: '¿Ofrecen descuentos por volumen?',
                    answer: '¡Sí! Ofrecemos descuentos por volumen escalonados que se aplican automáticamente a medida que aumenta tu volumen de pedidos. Cuanto más envíes, más ahorras.'
                },
                {
                    category: 'Gestión de Inventario',
                    question: '¿Cómo envío inventario a su almacén?',
                    answer: 'Podemos coordinar directamente con tus proveedores, o puedes enviar inventario a nuestro almacén usando cualquier transportista. Proporcionamos instrucciones detalladas de recepción.'
                },
                {
                    category: 'Gestión de Inventario',
                    question: '¿Puedo rastrear mi inventario en tiempo real?',
                    answer: '¡Absolutamente! Nuestro panel proporciona seguimiento de inventario en tiempo real, incluidos niveles de stock, envíos entrantes y estado de pedidos.'
                },
                {
                    category: 'Gestión de Inventario',
                    question: '¿Qué pasa si el inventario se agota?',
                    answer: 'Nuestro sistema envía automáticamente alertas de stock bajo, y nuestro equipo te notificará proactivamente para asegurarse de que nunca te quedes sin artículos populares.'
                },
                {
                    category: 'Envío y Entrega',
                    question: '¿Con qué transportistas trabajan?',
                    answer: 'Nos asociamos con todos los transportistas principales, incluidos FedEx, UPS, DHL, USPS y transportistas regionales para garantizar las mejores tarifas y tiempos de entrega.'
                },
                {
                    category: 'Envío y Entrega',
                    question: '¿Ofrecen envío internacional?',
                    answer: '¡Sí! Enviamos a más de 150 países de todo el mundo con rutas de envío internacional optimizadas y soporte de despacho aduanero.'
                },
                {
                    category: 'Envío y Entrega',
                    question: '¿Cuál es su tiempo promedio de entrega?',
                    answer: 'Los pedidos domésticos normalmente se entregan en 2-5 días hábiles, mientras que los pedidos internacionales tardan 5-14 días hábiles según el destino.'
                },
                {
                    category: 'Devoluciones y Cambios',
                    question: '¿Cómo funcionan las devoluciones?',
                    answer: '¡Nos encargamos de las devoluciones en tu nombre! Los clientes envían devoluciones a nuestro almacén, las inspeccionamos y actualizamos tu inventario en consecuencia.'
                },
                {
                    category: 'Devoluciones y Cambios',
                    question: '¿Pueden manejar cambios?',
                    answer: 'Sí, podemos gestionar todo el proceso de cambio, incluidas inspección, reabastecimiento y envío de artículos de reemplazo a tus clientes.'
                },
                {
                    category: 'Devoluciones y Cambios',
                    question: '¿Cuál es su tiempo de procesamiento de devoluciones?',
                    answer: 'Las devoluciones normalmente se procesan dentro de las 24-48 horas de su recepción, y tu inventario se actualiza inmediatamente en nuestro sistema.'
                },
                {
                    category: 'Soluciones Personalizadas',
                    question: '¿Pueden manejar empaques personalizados?',
                    answer: '¡Absolutamente! Ofrecemos empaques personalizados, insertos de marca, envoltorio de regalo y servicios de presentación especial para elevar tu marca.'
                },
                {
                    category: 'Soluciones Personalizadas',
                    question: '¿Soportan kits y ensamblaje?',
                    answer: '¡Sí! Proporcionamos servicios de kits, ensamblaje, empaquetado y personalización de productos para crear combinaciones de productos únicas.'
                },
                {
                    category: 'Soluciones Personalizadas',
                    question: '¿Pueden integrarse con mi plataforma?',
                    answer: 'Nos integramos con todas las plataformas principales de comercio electrónico, incluidas Shopify, WooCommerce, BigCommerce, Magento y más. ¡Contáctanos sobre integraciones personalizadas!'
                }
            ]
        },
        footer: {
            about: 'Sobre Nosotros',
            company: 'Perfil de la Empresa',
            team: 'Miembros del Equipo',
            news: 'Noticias',
            careers: 'Únete a Nosotros',
            solutions: 'Soluciones',
            dropshipping: 'Dropshipping',
            fulfillment: 'Cumplimiento',
            logistics: 'Logística',
            custom: 'Soluciones Personalizadas',
            support: 'Soporte',
            help: 'Centro de Ayuda',
            faq: 'Preguntas Frecuentes',
            contact: 'Contacto',
            privacy: 'Política de Privacidad',
            contactInfo: 'Información de Contacto',
            email: 'Correo: 270302301@qq.com',
            phone: 'Teléfono: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 Plataforma de Comercio Electrónico Transfronterizo FULFILLDROP. Todos los derechos reservados.'
        }
    },
    fr: {
        nav: {
            home: 'Accueil',
            solutions: 'Solutions',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistique',
            products: 'Produits',
            platform: 'Plateforme',
            pricing: 'Tarifs',
            faq: 'FAQ',
            about: 'À Propos',
            contact: 'Contact',
            getStarted: 'Commencer',
            resources: 'Ressources'
        },
        megamenu: {
            solByType: 'Par Type',
            solPopular: 'Populaire',
            solMostPopular: 'Le Plus Populaire',
            solBrandedPackaging: 'Emballage de Marque',
            solBrandedPackagingDesc: 'Emballage personnalisé, inserts et expérience de déballage',
            solExplore: 'Explorer',
            solNew: 'Nouveau',
            solAPI: 'Intégration API',
            solAPIDesc: 'Accès API complet pour une intégration transparente',
            solLearnMore: 'En Savoir Plus',
            platCoreFeatures: 'Caractéristiques Principales',
            platOrderMgmt: 'Gestion des Commandes',
            platInventory: 'Contrôle d\'Inventaire',
            platInventoryDesc: 'Suivi et alertes d\'inventaire en temps réel',
            platQC: 'Contrôle Qualité',
            platQCDesc: 'Processus d\'inspection multi-étapes',
            platAnalytics: 'Analytiques et Rapports',
            platAnalyticsDesc: 'Analytiques de performance complètes',
            platIntegrations: 'Intégrations',
            platShopify: 'Shopify',
            platShopifyDesc: 'Intégration transparente avec Shopify',
            platTikTokDesc: 'Intégration de fulfillment avec TikTok Shop',
            platWoo: 'WooCommerce',
            platWooDesc: 'Support d\'intégration avec WooCommerce',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: 'Technologie',
            platREST: 'API REST',
            platRESTDesc: 'API RESTful complète pour développement personnalisé',
            platWebhooksDesc: 'Notifications webhook en temps réel',
            platSecurity: 'Sécurité',
            platSecurityDesc: 'Mesures de sécurité de niveau entreprise',
            platTracking: 'Suivi',
            platTrackingDesc: 'Suivi de colis en temps réel',
            resHelpCenter: 'Centre d\'Aide',
            resGuides: 'Guides',
            resGuidesDesc: 'Guides détaillés de configuration et d\'optimisation',
            resVideoDemos: 'Démonstrations Vidéo',
            resVideoDemosDesc: 'Tutoriels visuels et explications',
            resInsights: 'Perspectives',
            resBlog: 'Blog',
            resCaseStudies: 'Études de Cas',
            resCaseStudiesDesc: 'Histoires de succès réelles de nos clients',
            resEbooks: 'Ebooks',
            resEbooksDesc: 'Rapports et guides détaillés de l\'industrie',
            resDevelopers: 'Développeurs',
            resAPIDocs: 'Docs API',
            resAPIDocsDesc: 'Documentation API complète',
            resIntegration: 'Intégration',
            resIntegrationDesc: 'Guides et outils d\'intégration',
            resStatus: 'État',
            compAbout: 'À Propos',
            compTeam: 'Notre Équipe',
            compTeamDesc: 'Rencontrez nos experts',
            compCareers: 'Carrières',
            compCareersDesc: 'Rejoignez notre équipe en croissance',
            compContactDesc: 'Contactez-nous'
        },
        hero: {
            title1: 'Solutions Intégrales de Chaîne d\'Approvisionnement Chine:',
            title2: 'Adaptées à Chaque Étape de la Croissance du Vendeur',
            description: 'De la sélection et de l\'approvisionnement des produits au contrôle de qualité, à la logistique globale et à la fabrication personnalisée, nous autonomisons les vendeurs avec une livraison fiable, une exécution rationalisée et une croissance durable.',
            btn: 'Obtenir un Devis',
            trust1: 'Approvisionnement + Fulfillment + Expédition',
            trust2: 'Conçu pour 10-10000+ commandes/jour',
            trust3: 'SLA transparent et gestion des exceptions'
        },
        capabilities: {
            title: 'Nos Capacités',
            items: [
                { number: '01', title: 'Rendre votre magasin unique et attractif', description: 'Peu importe où vous possédez votre magasin, sur Shopify, WooCommerce, vous pouvez créer des magasins personnalisés avec l\'équipe FULFILLDROP.' },
                { number: '02', title: 'Travailler avec des fournisseurs stables', description: 'Pour éviter les problèmes d\'essayer de nombreux fournisseurs pour trouver les meilleurs, FULFILLDROP sélectionne des fournisseurs fiables et qualifiés pour vous faire gagner du temps et de l\'argent.' },
                { number: '03', title: 'Traiter efficacement les commandes du magasin', description: 'Que votre magasin ait beaucoup de commandes ou qu\'il soit tout juste ouvert, il est toujours judicieux d\'améliorer l\'efficacité du travail pour faire une bonne impression sur vos clients.' },
                { number: '04', title: 'Prix des produits avec de grandes marges', description: 'Vendre en ligne peut être très compétitif, les prix de vos produits peuvent être la clé pour gagner des clients potentiels. Utilisez FULFILLDROP pour garantir des profits et plus de ventes.' },
                { number: '05', title: 'Offrir un service client exemplaire', description: 'En plus d\'un excellent service avant-vente, la livraison rapide et la notification en temps opportun de l\'état de la commande sont des facteurs importants qui augmentent le taux de rétention des clients.' },
                { number: '06', title: 'Rester au courant des tendances de l\'industrie', description: 'Les dropshippers doivent rester à jour sur les dernières stratégies, astuces et technologies de dropshipping pour tirer parti de nouvelles opportunités.' }
            ]
        },
        supplyChain: {
            title: 'Solutions Intégrales de Chaîne d\'Approvisionnement Chine',
            subtitle: 'Conçues pour une Exécution Évolutive',
            items: [
                { title: 'Exécution Consciente des Catégories', description: 'Construite autour des variables qui se brisent à l\'échelle : variantes, dommages, cohérence par lot et gestion des risques' },
                { title: 'Stabilité d\'Approvisionnement', description: 'Coordination d\'usines, planification de reconstitution et correspondance de substitution pour maintenir une exécution stable lorsque la demande augmente brusquement' },
                { title: 'Exécution de Personnalisation', description: 'Flux de travail d\'échantillonnage à production plus emballage/insertions : exécutés de manière cohérente dans le cadre du fulfillment' },
                { title: 'Fulfillment Contrôlé', description: 'Flux de travail vérifiés de tri, emballage et expédition avec propriété claire : pour que l\'échelle n\'augmente pas les erreurs' },
                { title: 'Visibilité et Exceptions', description: 'Synchronisation des commandes, visibilité des stocks, retour de suivi et règles structurées après-vente' }
            ]
        },
        businessModels: {
            title: 'Solutions Adaptées à Votre Modèle d\'Entreprise',
            subtitle: 'Les différents vendeurs priorisent différents Résultats Clés',
            items: [
                { title: 'Solutions de Dropshipping', description: 'Approvisionnement Stable + Exécution Évolutive Assurer un approvisionnement constant et une exécution à haute vitesse pour soutenir vos produits gagnants et votre rythme publicitaire agressif.' },
                { title: 'Solutions de Marque DTC', description: 'Cohérence de Marque de Bout en Bout Maintenir une expérience de marque premium de la production à la livraison, garantissant que la qualité ne faiblit jamais même à mesure que vous évoluez à l\'échelle mondiale.' },
                { title: 'Solutions de Fulfillment pour le Commerce Électronique', description: 'Cadre Systématique pour les Commandes de Haut Volume Fulfillment conçu avec précision pour une haute vitesse de commande : Précision inégalée, efficacité maximale et contrôle des coûts prévisible.' },
                { title: 'Solutions 3PL / à Fort Stock', description: 'Responsabilité et Contrôle Multi-Canal Obtenir une visibilité complète des stocks, coûts et responsabilité opérationnelle. Parfaitement adapté à la logistique multi-warehouse et multi-canal.' },
                { title: 'Solutions POD / Personnalisation', description: 'Systèmes Réplicables pour une Échelle Sur Mesure Un cadre robuste pour la production personnalisée et la livraison. Nous ne nous contentons pas de "le faire"—nous construisons un système qui évolue avec votre croissance.' }
            ]
        },
        operatingSystem: {
            title: 'Construit sur un Système d\'Exploitation de Chaîne d\'Approvisionnement Unifié',
            subtitle: 'Six modules principaux fonctionnent comme un système intégré : construit pour maintenir une exécution stable à mesure que votre entreprise évolue',
            items: [
                { title: 'Résilience et Stabilité d\'Approvisionnement', description: 'Garder les produits les plus vendus en stock avec un approvisionnement fiable, un reconstitution rapide et des options de substitution.', highlight: 'Équipe d\'approvisionnement de 28 personnes · 1.7M+ SKUs' },
                { title: 'Personnalisation Évolutive', description: 'Exécuter POD / OEM / ODM avec support d\'échantillonnage à production et exécution cohérente d\'emballage.', highlight: 'POD / OEM / ODM · Logos, insertions et boîtes extérieures' },
                { title: 'Gestion Intégrée des Entrepôts et des Stocks', description: 'Contrôler les stocks et l\'exécution 3PL avec discipline SKU, consolidation et préparation multi-canal.', highlight: 'Stockage + 3PL · Shopify / Yampi / Nuvemshop' },
                { title: 'Logistique Mondiale à Haut Débit', description: 'Livrer de manière prévisible avec des itinéraires dédiés, un support douanier et un suivi en temps réel.', highlight: '98% des commandes expédiées en 24h · Brésil, États-Unis et voies de l\'UE' },
                { title: 'Assurance Qualité et Gestion des Exceptions', description: 'Prévenir les problèmes évitables avant l\'expédition avec des contrôles QC et une propriété claire des exceptions.', highlight: 'QC pré-expédition · Gestion des dommages / pertes / exceptions' },
                { title: 'Support Après-Vente', description: 'Résoudre les problèmes après-vente avec des flux de travail standardisés et améliorer l\'exécution grâce à la rétroaction des données.', highlight: 'Support multilingue · SOPs de renvoi / remboursement' }
            ]
        },
        whoUses: {
            title: 'Qui utilise FULFILLDROP?',
            subtitle: 'Nous aidons les propriétaires de magasins de commerce électronique à développer leur activité de dropshipping en magasins de marque mondiale D2C',
            items: [
                { icon: 'briefcase', title: 'Entrepreneurs de Dropshipping', description: 'Les entrepreneurs ont 99 problèmes, le fulfillment ne devrait pas être un d\'entre eux. Avec un suivi automatique des stocks et un traitement fluide des commandes, FULFILLDROP maintient vos opérations en bon fonctionnement!' },
                { icon: 'users', title: 'Influenceurs sur les Réseaux Sociaux', description: 'Les influenceurs sont des actifs marketing puissants pour de nombreuses marques de commerce électronique. FULFILLDROP priorise le contrôle de la qualité et la satisfaction client, donnant aux influenceurs confiance lors de la promotion de produits que nous exécutons.' },
                { icon: 'chart-line', title: 'Professionnels du Commerce Électronique', description: 'Les professionnels du commerce électronique s\'appuient sur des systèmes rationalisés et efficaces pour maintenir leurs activités en bon fonctionnement. L\'ERP d\'FULFILLDROP s\'intègre aux principales plateformes pour automatiser et simplifier l\'ensemble du flux de traitement des commandes.' }
            ]
        },
        caseStudy: {
            title: 'Études de Cas',
            subtitle: 'Cas réels : Comment FULFILLDROP aide les vendeurs à réaliser une croissance commerciale explosive',
            badge: 'Cas de Succès',
            caseTitle: 'L\'Histoire de Croissance Commerciale de Warren',
            intro: 'Warren est un entrepreneur de dropshipping spécialisé dans les produits pour la maison. Grâce à la collaboration avec FULFILLDROP, il a réalisé une croissance de 6 fois en volume de commandes, passant de 3 000 à 18 000 en moins d\'un an, étendant significativement l\'échelle de son activité.',
            factors: { title: 'Facteurs Clés de Succès:', items: ['Utilisation d\'outils de recherche de produits pilotés par l\'IA pour découvrir des produits à haut potentiel', 'Obtention des prix les plus compétitifs via le réseau global de la chaîne d\'approvisionnement', 'Approvisionnement rapide de 48 heures pour garantir un réapprovisionnement opportun et éviter les ruptures de stock', 'Livraison globale de 5-12 jours pour améliorer la satisfaction client', 'Services de personnalisation de marque pour renforcer la fidélité client', 'Traitement automatisé des commandes et gestion des stocks pour économiser du temps opérationnel'] },
            results: { title: 'Résultats:', items: [{ number: '6x', label: 'Expansion de l\'Échelle Commerciale' }, { number: '40%', label: 'Amélioration de la Satisfaction Client' }, { number: '30%', label: 'Réduction des Coûts Opérationnels' }] },
            btn: 'Voir le Cas Complet'
        },
        contact: {
            title: 'Contactez-Nous',
            subtitle: 'Des questions sur FULFILLDROP? Remplissez le formulaire ci-dessous et notre équipe vous contactera dans les 24 heures.',
            form: { title: 'Contactez-Nous', text1: 'Des questions sur FULFILLDROP? Consultez notre FAQ pour obtenir des réponses à nos questions les plus fréquentes.', text2: 'Encore besoin d\'aide? Nous sommes là pour vous! Contactez-nous ci-dessous pour en savoir plus!', name: 'Nom', email: 'Adresse Email', phone: 'Téléphone', message: 'Message', placeholder: { name: 'Entrez votre nom', email: 'Entrez votre email', phone: 'Entrez votre numéro de téléphone', message: 'Décrivez brièvement vos besoins commerciaux' }, btn: 'Soumettre' },
            info: { title: 'Informations de Contact', items: [{ icon: 'phone', text: '+86 18905051115' }, { icon: 'whatsapp', text: 'WhatsApp: 0086 18905051115' }, { icon: 'envelope', text: '270302301@qq.com' }, { icon: 'envelope', text: 'colin270302301@gmail.com' }] }
        },
        partners: { title: 'Partenaires Mondiaux', subtitle: 'Nous nous associons avec les principales plateformes de commerce électronique et fournisseurs de services logistiques à l\'échelle mondiale pour vous offrir les meilleures solutions de commerce électronique transfrontalier' },
        home: {
            trusted: 'Fait confiance par 100+ Vendeurs Cross-Border',
            operationsLive: 'Opérations en Direct',
            dispatch24h: 'Commandes expédiées en 24h',
            skuAvailable: 'SKUs Disponibles pour l\'Approvisionnement',
            integratedWith: 'Intégré avec',
            statsQuote: 'Les chiffres racontent la vraie histoire — nous opérons à l\'échelle.',
            whyChoose: 'Pourquoi Choisir FULFILLDROP',
            whySubtitle: 'Conçu pour des opérations qui évoluent',
            whyDesc: 'Nous n\'attendons pas que les problèmes apparaissent. Nous construisons des systèmes qui les préviennent.',
            why1Title: 'Contrôle Qualité Proactif',
            why1Desc: 'Nous identifions et résolvons les problèmes avant qu\'ils n\'impactent vos clients. QC multi-points, vérifications pré-expédition et prévention des dommages intégrés à chaque commande.',
            why2Title: 'Communication Synchronisée',
            why2Desc: 'Plus de devinettes. Obtenez des mises à jour en temps réel sur l\'approvisionnement, la production et l\'expédition — tout en une seule vue. Vos clients obtiennent des informations précises, plus vite.',
            why3Title: 'Flexibilité Personnalisée',
            why3Desc: 'POD, OEM, ODM — nous gérons l\'emballage personnalisé, les inserts et le branding pour que votre expérience de déballage corresponde à votre promesse de marque.',
            industryTitle: 'Spécialisation Profonde dans les Catégories Clés',
            industrySubtitle: 'Nous comprenons les défis uniques de chaque catégorie — et avons construit des solutions ciblées.',
            industry1Title: 'Mode et Vêtements',
            industry1Desc: 'Variantes de taille, QC de tissus et étiquetage personnalisé — nous gérons la complexité du fulfillment de mode avec précision.',
            industry2Title: 'Suppléments de Santé',
            industry2Desc: 'Suivi par lots, documentation de conformité et stockage certifié — conçu pour la sécurité et la confiance des suppléments.',
            industry3Title: 'Éclairage et Décoration Maison',
            industry3Desc: 'Protocoles de manipulation fragile, couverture d\'assurance et emballage protecteur — vos produits arrivent intacts.',
            statsOrders: 'Commandes Quotidiennes Traitées',
            ctaPrimary: 'Parler à un Expert',
            ctaSecondary: 'En Savoir Plus Sur Notre Plateforme',
            talkExpert: 'Parler à un Expert',
            viewAllSolutions: 'Voir Toutes les Solutions',
            explorePlatform: 'Explorer la Plateforme',
            capEyebrow: 'Capacités Principales',
            solEyebrow: 'Solutions',
            solSubtitle: 'Choisissez le modèle qui correspond à votre étape et complexité'
        },
        faq: {
            title: 'Questions Fréquentes',
            description: 'Trouvez des réponses aux questions courantes sur nos services',
            questions: 'Questions',
            contactTitle: 'Toujours des Questions?',
            contactText: 'Notre équipe est là pour vous aider avec toutes les questions que vous pourriez avoir',
            contactBtn: 'Nous Contacter',
            items: [
                {
                    category: 'Démarrer',
                    question: 'Comment commencer avec vos services de fulfillment?',
                    answer: 'C\'est facile! Créez simplement un compte, connectez votre boutique et envoyez-nous votre inventaire. Notre équipe d\'intégration vous guidera à chaque étape.'
                },
                {
                    category: 'Démarrer',
                    question: 'Quels sont les exigences minimales de commande?',
                    answer: 'Nous n\'avons pas d\'exigences minimales de commande! Que vous expédiiez 10 commandes par jour ou 10 000, nous pouvons répondre à vos besoins.'
                },
                {
                    category: 'Démarrer',
                    question: 'Combien de temps dure l\'intégration?',
                    answer: 'L\'intégration prend généralement 3-5 jours ouvrables, selon la complexité de votre inventaire. Nous travaillons diligemment pour vous mettre en marche le plus rapidement possible.'
                },
                {
                    category: 'Tarification et Frais',
                    question: 'Comment est structurée votre tarification?',
                    answer: 'Notre tarification est transparente et basée sur les frais de ramassage-emballage-expédition plus le stockage. Nous offrons des réductions sur le volume pour les vendeurs à haut volume. Contactez-nous pour un devis personnalisé.'
                },
                {
                    category: 'Tarification et Frais',
                    question: 'Y a-t-il des frais cachés?',
                    answer: 'Pas de frais cachés! Tous nos frais sont clairement décrits dans votre contrat. Nous croyons en une tarification transparente pour que vous puissiez budgéter efficacement.'
                },
                {
                    category: 'Tarification et Frais',
                    question: 'Offrez-vous des réductions sur le volume?',
                    answer: 'Oui! Nous offrons des réductions sur le volume par paliers qui s\'appliquent automatiquement à mesure que votre volume de commandes augmente. Plus vous expédiez, plus vous économisez.'
                },
                {
                    category: 'Gestion d\'Inventaire',
                    question: 'Comment envoyer l\'inventaire à votre entrepôt?',
                    answer: 'Nous pouvons coordonner directement avec vos fournisseurs, ou vous pouvez expédier l\'inventaire à notre entrepôt en utilisant n\'importe quel transporteur. Nous fournissons des instructions détaillées de réception.'
                },
                {
                    category: 'Gestion d\'Inventaire',
                    question: 'Puis-je suivre mon inventaire en temps réel?',
                    answer: 'Absolument! Notre tableau de bord fournit un suivi d\'inventaire en temps réel, y compris les niveaux de stock, les expéditions entrantes et l\'état des commandes.'
                },
                {
                    category: 'Gestion d\'Inventaire',
                    question: 'Que se passe-t-il si l\'inventaire s\'épuisent?',
                    answer: 'Notre système envoie automatiquement des alertes de stock bas, et notre équipe vous informera proactivement pour vous assurer de ne jamais manquer d\'articles populaires.'
                },
                {
                    category: 'Expédition et Livraison',
                    question: 'Avec quels transporteurs travaillez-vous?',
                    answer: 'Nous nous associons à tous les transporteurs majeurs, y compris FedEx, UPS, DHL, USPS et des transporteurs régionaux pour garantir les meilleurs tarifs et délais de livraison.'
                },
                {
                    category: 'Expédition et Livraison',
                    question: 'Offrez-vous l\'expédition internationale?',
                    answer: 'Oui! Nous expédions à plus de 150 pays dans le monde avec des routes d\'expédition internationales optimisées et un support de dédouanement.'
                },
                {
                    category: 'Expédition et Livraison',
                    question: 'Quel est votre temps de livraison moyen?',
                    answer: 'Les commandes domestiques sont généralement livrées en 2-5 jours ouvrables, tandis que les commandes internationales prennent 5-14 jours ouvrables selon la destination.'
                },
                {
                    category: 'Retours et Échanges',
                    question: 'Comment fonctionnent les retours?',
                    answer: 'Nous gérons les retours en votre nom! Les clients envoyent les retours à notre entrepôt, nous les inspectons et mettons à jour votre inventaire en conséquence.'
                },
                {
                    category: 'Retours et Échanges',
                    question: 'Pouvez-vous gérer les échanges?',
                    answer: 'Oui, nous pouvons gérer l\'ensemble du processus d\'échange, y compris l\'inspection, le réapprovisionnement et l\'expédition des articles de remplacement à vos clients.'
                },
                {
                    category: 'Retours et Échanges',
                    question: 'Quel est votre temps de traitement des retours?',
                    answer: 'Les retours sont généralement traités dans les 24-48 heures de réception, et votre inventaire est mis à jour immédiatement dans notre système.'
                },
                {
                    category: 'Solutions Personnalisées',
                    question: 'Pouvez-vous gérer l\'emballage personnalisé?',
                    answer: 'Absolument! Nous offrons de l\'emballage personnalisé, des inserts de marque, du emballage cadeau et des services de présentation spéciale pour élever votre marque.'
                },
                {
                    category: 'Solutions Personnalisées',
                    question: 'Prenez-vous en charge le kitting et l\'assemblage?',
                    answer: 'Oui! Nous fournissons des services de kitting, d\'assemblage, de groupement et de personnalisation de produits pour créer des combinaisons de produits uniques.'
                },
                {
                    category: 'Solutions Personnalisées',
                    question: 'Pouvez-vous vous intégrer avec ma plateforme?',
                    answer: 'Nous nous intégrons avec toutes les plateformes de commerce électronique majeures, y compris Shopify, WooCommerce, BigCommerce, Magento et plus. Contactez-nous pour les intégrations personnalisées!'
                }
            ]
        },
        footer: {
            about: 'À Propos',
            company: 'Profil de l\'Entreprise',
            team: 'Membres de l\'Équipe',
            news: 'Actualités',
            careers: 'Rejoignez-Nous',
            solutions: 'Solutions',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistique',
            custom: 'Solutions Personnalisées',
            support: 'Support',
            help: 'Centre d\'Aide',
            faq: 'FAQ',
            contact: 'Contact',
            privacy: 'Politique de Confidentialité',
            contactInfo: 'Informations de Contact',
            email: 'Email: 270302301@qq.com',
            phone: 'Téléphone: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 Plateforme de Commerce Électronique Transfrontalier FULFILLDROP. Tous droits réservés.'
        }
    },
    zh: {
        nav: {
            home: '首页',
            solutions: '解决方案',
            dropshipping: '代发货',
            fulfillment: '仓储配送',
            logistics: '物流服务',
            products: '产品',
            platform: '平台',
            pricing: '价格',
            faq: '常见问题',
            about: '关于我们',
            contact: '联系我们',
            getStarted: '立即合作',
            resources: '资源'
        },
        megamenu: {
            solByType: '按类型',
            solPopular: '热门',
            solMostPopular: '最热门',
            solBrandedPackaging: '品牌包装',
            solBrandedPackagingDesc: '定制包装、插页和开箱体验',
            solExplore: '探索',
            solNew: '新品',
            solAPI: 'API 集成',
            solAPIDesc: '完整的 API 访问，实现无缝集成',
            solLearnMore: '了解更多',
            platCoreFeatures: '核心功能',
            platOrderMgmt: '订单管理',
            platInventory: '库存控制',
            platInventoryDesc: '实时库存跟踪和告警',
            platQC: '质量控制',
            platQCDesc: '多步检查流程',
            platAnalytics: '分析报告',
            platAnalyticsDesc: '全面的绩效分析',
            platIntegrations: '集成',
            platShopify: 'Shopify',
            platShopifyDesc: '无缝的 Shopify 店铺集成',
            platTikTokDesc: 'TikTok Shop 履约集成',
            platWoo: 'WooCommerce',
            platWooDesc: 'WooCommerce 集成支持',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: '技术',
            platREST: 'REST API',
            platRESTDesc: '完整的 RESTful API，支持自定义开发',
            platWebhooksDesc: '实时 webhook 通知',
            platSecurity: '安全',
            platSecurityDesc: '企业级安全措施',
            platTracking: '跟踪',
            platTrackingDesc: '实时包裹跟踪',
            resHelpCenter: '帮助中心',
            resGuides: '指南',
            resGuidesDesc: '详细的设置和优化指南',
            resVideoDemos: '视频演示',
            resVideoDemosDesc: '视觉教程和演示',
            resInsights: '洞察',
            resBlog: '博客',
            resCaseStudies: '案例研究',
            resCaseStudiesDesc: '我们客户的真实成功故事',
            resEbooks: '电子书',
            resEbooksDesc: '深入的行业报告和指南',
            resDevelopers: '开发者',
            resAPIDocs: 'API 文档',
            resAPIDocsDesc: '完整的 API 文档',
            resIntegration: '集成',
            resIntegrationDesc: '集成指南和工具',
            resStatus: '状态',
            compAbout: '关于我们',
            compTeam: '我们的团队',
            compTeamDesc: '认识我们的专家团队',
            compCareers: '招聘',
            compCareersDesc: '加入我们成长中的团队',
            compContactDesc: '联系我们'
        },
        hero: {
            title1: '跨境电商品牌的中国供应链合作伙伴',
            title2: '从起量到规模化，交付始终稳定',
            description: '我们提供选品采购、质检、仓储履约、全球物流与售后支持，帮助卖家把供应链从"能发货"升级为"可复制增长"。',
            btn: '咨询合作方案',
            trust1: '选品采购 + 仓储履约 + 全球物流',
            trust2: '支持日均 10-10000+ 单增长阶段',
            trust3: 'SLA 透明 + 异常闭环机制'
        },
        capabilities: {
            title: '我们重点解决的问题',
            items: [
                { number: '01', title: '供应稳定性', description: '通过合格工厂池、替代方案与补货计划，降低断货和供应波动风险。' },
                { number: '02', title: '订单履约效率', description: '打通订单同步与履约流程，减少人工操作和错发漏发，提升发货时效。' },
                { number: '03', title: '质量一致性', description: '建立关键质检节点与异常处理机制，保障规模化阶段的体验稳定。' },
                { number: '04', title: '定制化交付', description: '支持 POD / OEM / ODM 的打样到量产与包材执行，流程可复制。' },
                { number: '05', title: '全球物流可控', description: '通过稳定线路和物流追踪可视化，保持交付时效和成本可预测。' },
                { number: '06', title: '售后闭环', description: '标准化补发/退款流程，提升售后处理效率和客户满意度。' }
            ]
        },
        supplyChain: {
            title: '一站式中国供应链解决方案',
            subtitle: '基于主流跨境卖家增长模型沉淀的可执行体系',
            items: [
                { title: '类别感知执行', description: '围绕规模时会破裂的变量构建：变体、损坏、批次一致性和风险处理' },
                { title: '供应稳定性', description: '工厂协调、补货计划和替代匹配，以在需求激增时保持执行稳定' },
                { title: '定制执行', description: '从采样到生产的工作流程加上包装/插入物——在履行中一致执行' },
                { title: '受控履行', description: '经过验证的拣选-包装-发货工作流程，具有明确的所有权——因此规模不会增加错误' },
                { title: '可见性和例外情况', description: '订单同步、库存可见性、跟踪反馈和结构化售后规则' }
            ]
        },
        businessModels: {
            title: '为您的业务模型量身定制的解决方案',
            subtitle: '围绕不同阶段的利润目标、交付复杂度与渠道结构进行匹配',
            items: [
                { title: '代发货解决方案', description: '稳定的采购 + 可扩展的执行 确保一致的供应和高速执行，以支持您的获胜产品和积极的广告节奏。' },
                { title: 'DTC品牌解决方案', description: '端到端品牌一致性 从生产到交付保持优质品牌体验，确保质量在全球扩展时永不下降。' },
                { title: '电子商务履行解决方案', description: '高容量订单的系统框架 为高订单速度精心设计的履行：无与伦比的准确性、最高效率和可预测的成本控制。' },
                { title: '3PL / 库存密集型解决方案', description: '问责制和多渠道控制 全面了解库存、成本和运营问责制。完美适应多仓库和多渠道物流。' },
                { title: 'POD / 定制解决方案', description: '定制规模的可复制系统 定制生产和交付的强大框架。我们不仅仅是"制造它"——我们构建一个随您增长而扩展的系统。' }
            ]
        },
        operatingSystem: {
            title: '构建在统一的供应链操作系统上',
            subtitle: '从供应端到履约端统一协同，每个模块都围绕时效、质量、成本三项核心指标优化',
            items: [
                { title: '供应弹性和稳定性', description: '通过可靠的采购、快速补货和替代选项保持畅销产品的库存。', highlight: '28人采购团队 · 170万+ SKUs' },
                { title: '可扩展定制', description: '运行POD / OEM / ODM，提供从采样到生产的支持和一致的包装执行。', highlight: 'POD / OEM / ODM · 标志、插入物和外箱' },
                { title: '集成仓储和库存控制', description: '通过SKU纪律、整合和多渠道准备控制库存和3PL执行。', highlight: '库存 + 3PL · Shopify / Yampi / Nuvemshop' },
                { title: '高吞吐量全球物流', description: '通过专用路线、海关支持和实时跟踪可预测地交付。', highlight: '98%的订单在24小时内发货 · 巴西、美国和欧盟路线' },
                { title: '质量保证和例外管理', description: '在发货前通过QC检查和明确的例外所有权防止可避免的问题。', highlight: '发货前QC · 损坏/损失/例外处理' },
                { title: '售后支持', description: '通过标准化工作流程解决售后问题，并通过数据反馈改进执行。', highlight: '多语言支持 · 重新发货/退款SOP' }
            ]
        },
        whoUses: {
            title: '谁使用FULFILLDROP?',
            subtitle: '我们帮助电子商务商店老板将他们的代发货业务扩展到全球品牌D2C商店',
            items: [
                { icon: 'briefcase', title: '代发货企业家', description: '企业家有99个问题，履行不应该是其中之一。通过自动库存跟踪和无缝订单处理，FULFILLDROP让您的运营顺利运行！' },
                { icon: 'users', title: '社交媒体影响者', description: '影响者是许多电子商务品牌的强大营销资产。FULFILLDROP优先考虑质量控制和客户满意度，在推广我们履行的产品时，让有影响力的人充满信心。' },
                { icon: 'chart-line', title: '电子商务专业人士', description: '电子商务专业人士依靠精简、高效的系统来保持业务的顺利运行。FULFILLDROP的ERP与主要平台集成，以自动化和简化整个订单处理工作流程。' }
            ]
        },
        caseStudy: {
            title: '成功案例研究',
            subtitle: '真实案例：FULFILLDROP如何帮助卖家实现业务爆发式增长',
            badge: '成功案例',
            caseTitle: 'Warren的业务增长故事',
            intro: 'Warren是一位专注于家居产品的代发货企业家，通过与FULFILLDROP合作，在不到一年的时间里实现了订单量从3,000到18,000的6倍增长，业务规模显著扩大。',
            factors: { title: '关键成功因素：', items: ['利用AI驱动的产品研究工具，发现高潜力产品', '通过全球供应链网络获得最具竞争力的价格', '48小时快速采购确保及时补货，避免断货', '5-12天全球配送提升客户满意度', '品牌定制服务增强客户忠诚度', '自动化订单处理和库存管理节省运营时间'] },
            results: { title: '成果：', items: [{ number: '6x', label: '业务规模扩大' }, { number: '40%', label: '客户满意度提升' }, { number: '30%', label: '运营成本降低' }] },
            btn: '查看完整案例'
        },
        contact: {
            title: '联系我们',
            subtitle: '关于FULFILLDROP有任何问题？填写下面的表单，我们的团队将在24小时内与您联系。',
            form: { title: '联系我们', text1: '关于FULFILLDROP有问题？查看我们的常见问题，获取我们最常见问题的答案。', text2: '还需要帮助？我们在这里为您服务！在下面联系我们以了解更多信息！', name: '姓名', email: '邮箱地址', phone: '电话', message: '信息', placeholder: { name: '请输入您的姓名', email: '请输入您的邮箱', phone: '请输入您的电话', message: '请简要描述您的业务需求' }, btn: '提交' },
            info: { title: '联系信息', items: [{ icon: 'phone', text: '+86 18905051115' }, { icon: 'whatsapp', text: 'WhatsApp: 0086 18905051115' }, { icon: 'envelope', text: '270302301@qq.com' }, { icon: 'envelope', text: 'colin270302301@gmail.com' }] }
        },
        partners: { title: '全球合作伙伴', subtitle: '我们与主流电商平台和国际物流服务商深度协作，保障日常履约稳定运行' },
        home: {
            trusted: '100+ 跨境卖家的信赖之选',
            operationsLive: '实时运营',
            dispatch24h: '24小时内发货',
            skuAvailable: '可采购 SKU',
            integratedWith: '集成平台',
            statsQuote: '数据说明一切 — 我们规模化运营。',
            whyChoose: '为什么选择 FULFILLDROP',
            whySubtitle: '为规模化运营而构建',
            whyDesc: '我们不等待问题出现。我们构建系统来防止问题。',
            why1Title: '主动质量控制',
            why1Desc: '我们在问题影响您的客户之前识别并解决。多点质检、发货前检查和损坏预防内置在每个订单中。',
            why2Title: '同步通信',
            why2Desc: '不再猜测。在一个视图中获得采购、生产和发货的实时更新。您的客户更快获得准确信息。',
            why3Title: '定制灵活性',
            why3Desc: 'POD、OEM、ODM — 我们处理定制包装、插页和品牌，让您的开箱体验符合品牌承诺。',
            industryTitle: '关键品类的深度专业化',
            industrySubtitle: '我们理解每个品类的独特挑战 — 并已构建针对性解决方案。',
            industry1Title: '时尚与服装',
            industry1Desc: '尺寸变体、面料质检和定制标签 — 我们精准处理时尚履约的复杂性。',
            industry2Title: '健康补充剂',
            industry2Desc: '批次追踪、合规文档和认证存储 — 为补充剂安全和信任而构建。',
            industry3Title: '照明与家居装饰',
            industry3Desc: '易碎处理协议、保险覆盖和保护性包装 — 您的产品完好到达。',
            statsOrders: '每日处理订单',
            ctaPrimary: '与专家交谈',
            ctaSecondary: '了解更多关于我们的平台',
            talkExpert: '与专家交谈',
            viewAllSolutions: '查看所有解决方案',
            explorePlatform: '探索平台',
            capEyebrow: '核心能力',
            solEyebrow: '解决方案',
            solSubtitle: '选择符合您阶段和复杂性的模型'
        },
        faq: {
            title: '常见问题',
            description: '查找关于我们服务的常见问题解答',
            questions: '问题',
            contactTitle: '还有问题?',
            contactText: '我们的团队随时准备帮助您解答任何问题',
            contactBtn: '联系我们',
            items: [
                {
                    category: '开始使用',
                    question: '我如何开始使用您的履约服务?',
                    answer: '开始很简单！只需注册账户，连接您的店铺，然后向我们发送库存。我们的入职团队将引导您完成每一步。'
                },
                {
                    category: '开始使用',
                    question: '最低订单要求是什么?',
                    answer: '我们没有最低订单要求！无论您每天发货10个订单还是10,000个订单，我们都能满足您的需求。'
                },
                {
                    category: '开始使用',
                    question: '入职需要多长时间?',
                    answer: '入职通常需要3-5个工作日，具体取决于您的库存复杂性。我们会努力工作，让您尽快投入运营。'
                },
                {
                    category: '价格与费用',
                    question: '您的价格结构是怎样的?',
                    answer: '我们的价格是透明的，基于取件-包装-发货费用加上仓储费。我们为高销量卖家提供批量折扣。联系我们获取定制报价。'
                },
                {
                    category: '价格与费用',
                    question: '有隐藏费用吗?',
                    answer: '没有隐藏费用！我们所有的收费都在合同中明确说明。我们相信透明定价，以便您能有效地进行预算。'
                },
                {
                    category: '价格与费用',
                    question: '你们提供批量折扣吗?',
                    answer: '是的！我们提供分层批量折扣，随着您的订单量增加自动适用。发货越多，节省越多。'
                },
                {
                    category: '库存管理',
                    question: '我如何将库存发送到您的仓库?',
                    answer: '我们可以直接与您的供应商协调，或者您可以使用任何运输商将库存发送到我们的仓库。我们提供详细的收货说明。'
                },
                {
                    category: '库存管理',
                    question: '我可以实时跟踪我的库存吗?',
                    answer: '当然！我们的仪表板提供实时库存跟踪，包括库存水平、入库发货和订单状态。'
                },
                {
                    category: '库存管理',
                    question: '如果库存不足会发生什么?',
                    answer: '我们的系统会自动发送低库存警报，我们的团队会主动通知您，确保您永远不会耗尽热门商品。'
                },
                {
                    category: '运输与配送',
                    question: '您与哪些运输商合作?',
                    answer: '我们与所有主要运输商合作，包括FedEx、UPS、DHL、USPS和地区运输商，以确保最佳价格和配送时间。'
                },
                {
                    category: '运输与配送',
                    question: '你们提供国际运输吗?',
                    answer: '是的！我们向全球150多个国家发货，拥有优化的国际运输路线和清关支持。'
                },
                {
                    category: '运输与配送',
                    question: '您的平均配送时间是多长?',
                    answer: '国内订单通常在2-5个工作日内配送，而国际订单根据目的地需要5-14个工作日。'
                },
                {
                    category: '退换货',
                    question: '退换货如何运作?',
                    answer: '我们代表您处理退换货！客户将退货发送到我们的仓库，我们进行检查并相应更新您的库存。'
                },
                {
                    category: '退换货',
                    question: '你们能处理换货吗?',
                    answer: '是的，我们可以管理整个换货过程，包括检查、补货和向您的客户发送替换商品。'
                },
                {
                    category: '退换货',
                    question: '你们的退货处理时间是多长?',
                    answer: '退货通常在收到后24-48小时内处理，您的库存会在我们的系统中立即更新。'
                },
                {
                    category: '定制解决方案',
                    question: '你们能处理定制包装吗?',
                    answer: '当然！我们提供定制包装、品牌插页、礼品包装和特殊展示服务，提升您的品牌形象。'
                },
                {
                    category: '定制解决方案',
                    question: '你们支持套装和组装吗?',
                    answer: '是的！我们提供套装、组装、捆绑和产品定制服务，以创建独特的产品组合。'
                },
                {
                    category: '定制解决方案',
                    question: '你们能与我的平台集成吗?',
                    answer: '我们与所有主要电商平台集成，包括Shopify、WooCommerce、BigCommerce、Magento等。联系我们了解定制集成！'
                }
            ]
        },
        footer: {
            about: '关于我们',
            company: '公司简介',
            team: '团队成员',
            news: '新闻',
            careers: '加入我们',
            solutions: '解决方案',
            dropshipping: '代发货',
            fulfillment: '仓储配送',
            logistics: '物流服务',
            custom: '定制解决方案',
            support: '支持',
            help: '帮助中心',
            faq: '常见问题',
            contact: '联系我们',
            privacy: '隐私政策',
            contactInfo: '联系信息',
            email: '邮箱: 270302301@qq.com',
            phone: '电话: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 FULFILLDROP跨境电商平台。保留所有权利。'
        }
    },
    ja: {
        nav: {
            home: 'ホーム',
            solutions: 'ソリューション',
            dropshipping: 'ドロップシッピング',
            fulfillment: 'フルフィルメント',
            logistics: '物流',
            products: '製品',
            platform: 'プラットフォーム',
            pricing: '価格',
            faq: 'よくある質問',
            about: '会社概要',
            contact: 'お問い合わせ',
            getStarted: 'はじめる',
            resources: 'リソース'
        },
        megamenu: {
            solByType: 'タイプ別',
            solPopular: '人気',
            solMostPopular: '最も人気',
            solBrandedPackaging: 'ブランドパッケージ',
            solBrandedPackagingDesc: 'カスタムパッケージ、挿入物、アンボクシング体験',
            solExplore: '探検',
            solNew: '新着',
            solAPI: 'API統合',
            solAPIDesc: 'シームレスな統合のためのフルAPIアクセス',
            solLearnMore: '詳細を見る',
            platCoreFeatures: 'コア機能',
            platOrderMgmt: '注文管理',
            platInventory: '在庫管理',
            platInventoryDesc: 'リアルタイム在庫追跡とアラート',
            platQC: '品質管理',
            platQCDesc: '多段階検査プロセス',
            platAnalytics: 'アナリティクス＆レポート',
            platAnalyticsDesc: '包括的なパフォーマンス分析',
            platIntegrations: '統合',
            platShopify: 'Shopify',
            platShopifyDesc: 'Shopifyストアとのシームレスな統合',
            platTikTokDesc: 'TikTokショップフルフィルメント統合',
            platWoo: 'WooCommerce',
            platWooDesc: 'WooCommerce統合サポート',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: 'テクノロジー',
            platREST: 'REST API',
            platRESTDesc: 'カスタム開発のためのフルRESTful API',
            platWebhooksDesc: 'リアルタイムウェブフック通知',
            platSecurity: 'セキュリティ',
            platSecurityDesc: 'エンタープライズレベルのセキュリティ対策',
            platTracking: '追跡',
            platTrackingDesc: 'リアルタイムパッケージ追跡',
            resHelpCenter: 'ヘルプセンター',
            resGuides: 'ガイド',
            resGuidesDesc: '詳細なセットアップと最適化ガイド',
            resVideoDemos: 'ビデオデモ',
            resVideoDemosDesc: '視覚的なチュートリアルとウォークスルー',
            resInsights: '洞察',
            resBlog: 'ブログ',
            resCaseStudies: 'ケーススタディ',
            resCaseStudiesDesc: 'クライアントの実際の成功ストーリー',
            resEbooks: '電子書籍',
            resEbooksDesc: '業界レポートとガイド',
            resDevelopers: '開発者',
            resAPIDocs: 'APIドキュメント',
            resAPIDocsDesc: '完全なAPIドキュメンテーション',
            resIntegration: '統合',
            resIntegrationDesc: '統合ガイドとツール',
            resStatus: 'ステータス',
            compAbout: '会社概要',
            compTeam: 'チーム',
            compTeamDesc: '専門チームメンバーを紹介',
            compCareers: 'キャリア',
            compCareersDesc: '成長中のチームに参加',
            compContactDesc: 'お問い合わせ'
        },
        hero: {
            title1: 'クロスボーダーECブランドのための',
            title2: '中国サプライチェーンパートナー',
            description: '調達と品質管理から倉庫保管、フルフィルメント、グローバル配送まで、FULFILLDROPは急速成長するセラーが安定した運営を行い、自信を持って規模拡大するのを支援します。',
            btn: 'FULFILLDROPに相談',
            trust1: '調達＋フルフィルメント＋配送',
            trust2: '1日10-10000+注文向けに構築',
            trust3: '透明なSLAと例外処理'
        },
        capabilities: {
            title: '解決できる課題',
            items: [
                { number: '01', title: 'サプライヤー安定性', description: '審査済み工場、代替オプション、補充計画でバックアップ可能な供給を構築。' },
                { number: '02', title: '注文処理効率', description: '注文同期とフルフィルメントワークフローを自動化し、手動エラーを減らし、発送を加速。' },
                { number: '03', title: '品質と一貫性', description: '明確なQCチェックポイントと例外処理で、スケール時の顧客体験を保護。' },
                { number: '04', title: 'カスタマイズ配送', description: 'POD/OEM/ODMプロジェクトを再現可能なサンプリングから生産、パッケージ実行まで実行。' },
                { number: '05', title: 'グローバル配送信頼性', description: '安定したルートと追跡可視性を活用し、配送パフォーマンスを予測可能に。' },
                { number: '06', title: 'アフターセールス管理', description: '再発送/返金ワークフローを標準化し、成長中もサービス品質を維持。' }
            ]
        },
        supplyChain: {
            title: 'ワンストップ中国サプライチェーンソリューション',
            subtitle: '急速成長するセラーが使用する実践的な運用モデル',
            items: [
                { title: 'カテゴリ対応実行', description: 'スケール時に問題となる変数（バリアント、損傷、バッチ一貫性、リスク管理）を中心に構築' },
                { title: '多層サプライヤーネットワーク', description: 'プライマリーとバックアップサプライヤーを確保し、供給の安定性を維持' },
                { title: 'リアルタイム可視性', description: '注文、在庫、配送の全行程をリアルタイムで追跡可能' },
                { title: 'アジャイルなスケーリング', description: '需要の急激な変化に柔軟に対応可能なインフラストラクチャ' }
            ]
        },
        operatingSystem: {
            title: '統合サプライチェーンオペレーティングシステム上に構築',
            subtitle: '6つのコアモジュールが統合システムとして機能：ビジネスがスケールするにつれて安定した実行を維持するために構築',
            items: [
                { title: '供給の弾力性と安定性', description: '信頼性の高い供給、迅速な補充、代替オプションで最も売れている製品を在庫に保つ。', highlight: '28人の調達チーム・170万+ SKU' },
                { title: 'スケーラブルなカスタマイズ', description: 'サンプリングから生産までのサポートと一貫したパッケージ実行でPOD/OEM/ODMを実行。', highlight: 'POD/OEM/ODM・ロゴ、挿入物、外箱' },
                { title: '統合された保管と在庫管理', description: 'SKU管理、統合、マルチチャネル対応で在庫と3PL実行を管理。', highlight: '保管+3PL・Shopify/Yampi/Nuvemshop' },
                { title: '高性能グローバル物流', description: '専用ルート、税関支援、リアルタイム追跡で予測可能な配送。', highlight: '98%の注文が24時間以内に発送・ブラジル、米国、EUルート' },
                { title: '品質保証と例外管理', description: 'QC管理と明確な例外責任で発送前に回避可能な問題を防止。', highlight: '発送前QC・損傷/紛失/例外管理' },
                { title: 'アフターサポート', description: '標準化されたワークフローでアフターサポートを解決し、データフィードバックで実行を改善。', highlight: '多言語サポート・再発送/返金SOP' }
            ]
        },
        whoUses: {
            title: 'FULFILLDROPを使うのは誰ですか？',
            subtitle: 'ドロップシッピングからグローバルD2Cブランド店舗まで、EC店舗オーナーがビジネスをスケールするのを支援',
            items: [
                { icon: 'briefcase', title: 'ドロップシッピング起業家', description: '起業家には99の問題があり、フルフィルメントはその一つであるべきではありません。自動在庫追跡とスムーズな注文処理で、FULFILLDROPはあなたの運営を問題なく維持します！' },
                { icon: 'users', title: 'ソーシャルメディアインフルエンサー', description: 'インフルエンサーは多くのECブランドにとって強力なマーケティング資産です。FULFILLDROPは品質管理と顧客満足度を優先し、インフルエンサーが私たちがフルフィルする製品を宣伝する際の信頼を提供します。' },
                { icon: 'chart-line', title: 'ECプロフェッショナル', description: 'ECプロフェッショナルは、ビジネスをスムーズに運営するために効率的で最適化されたシステムを信頼しています。FULFILLDROPのERPは主要プラットフォームと統合し、注文処理フロー全体を自動化して簡素化します。' }
            ]
        },
        caseStudy: {
            title: 'ケーススタディ',
            subtitle: '実際の事例：FULFILLDROPがセラーのビジネス爆発的成長をどのように支援するか',
            badge: '成功事例',
            caseTitle: 'ウォーレンのビジネス成長ストーリー',
            intro: 'ウォーレンはホームプロダクツに特化したドロップシッピング起業家です。FULFILLDROPとの協力を通じて、注文量を3,000から18,000まで1年以内に6倍に成長させ、ビジネス規模を大幅に拡大しました。',
            factors: { title: '成功の鍵となる要素：', items: ['AI駆動の製品調査ツールを使用して高い可能性の製品を発見', 'グローバルサプライチェーンネットワークを通じて最も競争力のある価格を獲得', '48時間の迅速調達でタイムリーな補充を保証し、在庫切れを回避', '5-12日のグローバル配送で顧客満足度を向上', '顧客ロイヤルティを高めるためのブランドカスタマイズサービス', '注文自動処理と在庫管理で運用時間を節約'] },
            results: { title: '結果：', items: [{ number: '6倍', label: 'ビジネス規模の拡大' }, { number: '40%', label: '顧客満足度の向上' }, { number: '30%', label: '運用コストの削減' }] },
            btn: '完全な事例を見る'
        },
        contact: {
            title: 'お問い合わせ',
            subtitle: 'FULFILLDROPについて質問がありますか？以下のフォームに記入してください。弊社チームが24時間以内に連絡します。',
            form: { title: 'お問い合わせ', text1: 'FULFILLDROPについて質問がありますか？よくある質問セクションで最も一般的な質問の回答をご確認ください。', text2: 'まだお手伝いが必要ですか？こちらからお問い合わせください！', name: 'お名前', email: 'メールアドレス', phone: '電話番号', message: 'メッセージ', placeholder: { name: 'お名前を入力', email: 'メールアドレスを入力', phone: '電話番号を入力', message: 'ビジネスニーズを簡単に説明' }, btn: '送信' },
            info: { title: 'お問い合わせ情報', items: [{ icon: 'phone', text: '+86 18905051115' }, { icon: 'whatsapp', text: 'WhatsApp: 0086 18905051115' }, { icon: 'envelope', text: '270302301@qq.com' }, { icon: 'envelope', text: 'colin270302301@gmail.com' }] }
        },
        partners: { title: 'グローバルパートナー', subtitle: '世界有数のECプラットフォームと物流サービスプロバイダーと提携し、最高のクロスボーダーECソリューションを提供' },
        home: {
            trusted: '100+のクロスボーダーセラーに推奨',
            operationsLive: '運用中',
            dispatch24h: '24時間以内に発送',
            skuAvailable: '調達可能なSKU',
            integratedWith: '統合済み',
            statsQuote: '数字が真実のストーリーを語る：私たちはスケールで運用しています。',
            whyChoose: 'FULFILLDROPを選ぶ理由',
            whySubtitle: 'スケールする運用のために構築',
            whyDesc: '問題が発生するのを待つのではなく、問題を防ぐシステムを構築します。',
            why1Title: 'プロアクティブな品質管理',
            why1Desc: '問題が顧客に影響する前に識別して解決します。多点QC、発送前チェック、損傷防止がすべての注文に組み込まれています。',
            why2Title: '同期通信',
            why2Desc: '推測する必要はありません。調達、生産、発送のリアルタイム更新を1つのビューで取得します。顧客はより速く正確な情報を取得できます。',
            why3Title: 'カスタム柔軟性',
            why3Desc: 'POD、OEM、ODM — カスタムパッケージ、挿入物、ブランディングを処理し、アンボクシング体験がブランドの約束に合うようにします。',
            industryTitle: '主要カテゴリの深い専門知識',
            industrySubtitle: '各カテゴリの固有の課題を理解し、ターゲットソリューションを構築しました。',
            industry1Title: 'ファッション＆アパレル',
            industry1Desc: 'サイズバリアント、生地QC、カスタムラベリング — ファッションフルフィルメントの複雑さを正確に処理します。',
            industry2Title: 'ヘルスサプリメント',
            industry2Desc: 'バッチ追跡、コンプライアンス文書、認証保管 — サプリメントの安全性と信頼性のために構築。',
            industry3Title: '照明＆ホームデコレーション',
            industry3Desc: 'フラジャイルハンドリングプロトコル、保険補償、保護パッケージ — 製品が無傷で到着します。',
            statsOrders: '日次処理注文',
            ctaPrimary: '専門家に相談',
            ctaSecondary: 'プラットフォームについて詳しく知る',
            talkExpert: '専門家に相談',
            viewAllSolutions: 'すべてのソリューションを見る',
            explorePlatform: 'プラットフォームを探索',
            capEyebrow: 'コア機能',
            solEyebrow: 'ソリューション',
            solSubtitle: 'あなたの段階と複雑さに合ったモデルを選択'
        },
        faq: {
            title: 'よくある質問',
            description: '当社サービスに関するよくある質問の回答を見つける',
            questions: '質問',
            contactTitle: 'まだ質問がありますか？',
            contactText: '当社チームは、お客様の質問にお答えするためにここにいます',
            contactBtn: 'お問い合わせ',
            items: [
                {
                    category: 'はじめに',
                    question: 'フルフィルメントサービスを開始するにはどうすればよいですか？',
                    answer: '開始は簡単です！アカウントにサインアップし、ストアを接続し、在庫を送信するだけです。オンボーディングチームが各ステップをガイドします。'
                },
                {
                    category: 'はじめに',
                    question: '最低注文要件は何ですか？',
                    answer: '最低注文要件はありません！1日10注文でも10,000注文でも、お客様のニーズに対応できます。'
                },
                {
                    category: 'はじめに',
                    question: 'オンボーディングにはどれくらい時間がかかりますか？',
                    answer: 'オンボーディングは通常、在庫の複雑さに応じて3-5営業日かかります。迅速に運用開始できるように努力しています。'
                },
                {
                    category: '価格と料金',
                    question: '価格はどのように構成されていますか？',
                    answer: '価格は透明で、ピックアンドパック配送料金に保管料を加えたものです。高ボリュームのセラーにはボリューム割引を提供します。カスタム見積もりについてはお問い合わせください。'
                },
                {
                    category: '価格と料金',
                    question: '隠れた料金はありますか？',
                    answer: '隠れた料金はありません！すべての料金は契約に明確に記載されています。予算を効果的に管理できるように透明な価格設定を信じています。'
                },
                {
                    category: '価格と料金',
                    question: 'ボリューム割引はありますか？',
                    answer: 'はい！注文量が増加するにつれて自動的に適用される段階的なボリューム割引を提供します。発送量が多いほど節約できます。'
                },
                {
                    category: '在庫管理',
                    question: '在庫を倉庫に送るにはどうすればよいですか？',
                    answer: 'サプライヤーと直接調整するか、任意のキャリアを使用して在庫を倉庫に発送できます。詳細な受け入れ手順を提供します。'
                },
                {
                    category: '在庫管理',
                    question: 'リアルタイムで在庫を追跡できますか？',
                    answer: 'もちろんです！ダッシュボードは、在庫レベル、入荷予定、注文ステータスを含むリアルタイムの在庫追跡を提供します。'
                },
                {
                    category: '在庫管理',
                    question: '在庫が不足した場合どうなりますか？',
                    answer: 'システムは自動的に在庫切れアラートを送信し、チームが積極的に通知して人気商品がなくならないようにします。'
                },
                {
                    category: '配送と配達',
                    question: 'どのキャリアと協力していますか？',
                    answer: 'FedEx、UPS、DHL、USPSを含むすべての主要キャリアと提携し、最良の料金と配達時間を確保しています。'
                },
                {
                    category: '配送と配達',
                    question: '国際配送は提供していますか？',
                    answer: 'はい！最適化された国際配送ルートと税関クリアランスサポートで世界150か国以上に配送しています。'
                },
                {
                    category: '配送と配達',
                    question: '平均配達時間はどれくらいですか？',
                    answer: '国内注文は通常2-5営業日で配達され、国際注文は目的地によって5-14営業日かかります。'
                },
                {
                    category: '返品と交換',
                    question: '返品はどのように機能しますか？',
                    answer: '代わりに返品を処理します！顧客は返品を倉庫に送り、検品して在庫を更新します。'
                },
                {
                    category: '返品と交換',
                    question: '交換に対応していますか？',
                    answer: 'はい、検品、補充、顧客への交換品配送を含む交換プロセス全体を管理できます。'
                },
                {
                    category: '返品と交換',
                    question: '返品処理時間はどれくらいですか？',
                    answer: '返品は通常、受領後24-48時間以内に処理され、在庫はシステムに即座に更新されます。'
                },
                {
                    category: 'カスタムソリューション',
                    question: 'カスタムパッケージに対応していますか？',
                    answer: 'もちろんです！ブランドを高めるためのカスタムパッケージ、ブランドインサート、ギフトラッピング、特別プレゼンテーションサービスを提供します。'
                },
                {
                    category: 'カスタムソリューション',
                    question: 'キッティングと組み立てに対応していますか？',
                    answer: 'はい！ユニークな製品コンビネーションを作成するためのキッティング、組み立て、バンドリング、製品カスタマイズサービスを提供します。'
                },
                {
                    category: 'カスタムソリューション',
                    question: 'プラットフォームと統合できますか？',
                    answer: 'Shopify、WooCommerce、BigCommerce、Magentoなど、すべての主要なECプラットフォームと統合しています。カスタム統合についてはお問い合わせください！'
                }
            ]
        },
        footer: {
            about: '会社概要',
            company: '企業プロフィール',
            team: 'チームメンバー',
            news: 'ニュース',
            careers: 'キャリア',
            solutions: 'ソリューション',
            dropshipping: 'ドロップシッピング',
            fulfillment: 'フルフィルメント',
            logistics: '物流',
            custom: 'カスタムソリューション',
            support: 'サポート',
            help: 'ヘルプセンター',
            faq: 'よくある質問',
            contact: 'お問い合わせ',
            privacy: 'プライバシーポリシー',
            contactInfo: 'お問い合わせ情報',
            email: 'メール: 270302301@qq.com',
            phone: '電話: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 FULFILLDROPクロスボーダーECプラットフォーム。All rights reserved.'
        }
    },
    de: {
        nav: {
            home: 'Startseite',
            solutions: 'Lösungen',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistik',
            products: 'Produkte',
            platform: 'Plattform',
            pricing: 'Preise',
            faq: 'FAQ',
            about: 'Über Uns',
            contact: 'Kontakt',
            getStarted: 'Loslegen',
            resources: 'Ressourcen'
        },
        megamenu: {
            solByType: 'Nach Typ',
            solPopular: 'Beliebt',
            solMostPopular: 'Am Beliebtesten',
            solBrandedPackaging: 'Markenverpackung',
            solBrandedPackagingDesc: 'Maßgeschneiderte Verpackung, Einlagen und Unboxing-Erlebnis',
            solExplore: 'Entdecken',
            solNew: 'Neu',
            solAPI: 'API-Integration',
            solAPIDesc: 'Voller API-Zugriff für nahtlose Integration',
            solLearnMore: 'Mehr erfahren',
            platCoreFeatures: 'Kernfunktionen',
            platOrderMgmt: 'Bestellverwaltung',
            platInventory: 'Inventarverwaltung',
            platInventoryDesc: 'Echtzeit-Bestandsverfolgung und -warnungen',
            platQC: 'Qualitätskontrolle',
            platQCDesc: 'Mehrstufiger Inspektionsprozess',
            platAnalytics: 'Analytics & Reports',
            platAnalyticsDesc: 'Umfassende Leistungsanalyse',
            platIntegrations: 'Integrationen',
            platShopify: 'Shopify',
            platShopifyDesc: 'Nahtlose Shopify-Shop-Integration',
            platTikTokDesc: 'TikTok Shop Fulfillment Integration',
            platWoo: 'WooCommerce',
            platWooDesc: 'WooCommerce-Integrationsunterstützung',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: 'Technologie',
            platREST: 'REST API',
            platRESTDesc: 'Vollständige RESTful API für benutzerdefinierte Entwicklung',
            platWebhooksDesc: 'Echtzeit-Webhook-Benachrichtigungen',
            platSecurity: 'Sicherheit',
            platSecurityDesc: 'Enterprise-Grade-Sicherheitsmaßnahmen',
            platTracking: 'Tracking',
            platTrackingDesc: 'Echtzeit-Paketverfolgung',
            resHelpCenter: 'Hilfecenter',
            resGuides: 'Handbücher',
            resGuidesDesc: 'Detaillierte Einrichtungs- und Optimierungshandbücher',
            resVideoDemos: 'Videodemos',
            resVideoDemosDesc: 'Visuelle Tutorials und Walkthroughs',
            resInsights: 'Einblicke',
            resBlog: 'Blog',
            resCaseStudies: 'Fallstudien',
            resCaseStudiesDesc: 'Echte Erfolgsgeschichten unserer Kunden',
            resEbooks: 'Ebooks',
            resEbooksDesc: 'Umfassende Branchenberichte und -handbücher',
            resDevelopers: 'Entwickler',
            resAPIDocs: 'API-Dokumentation',
            resAPIDocsDesc: 'Komplette API-Dokumentation',
            resIntegration: 'Integration',
            resIntegrationDesc: 'Integrationshandbücher und -tools',
            resStatus: 'Status',
            compAbout: 'Über Uns',
            compTeam: 'Unser Team',
            compTeamDesc: 'Lernen Sie unsere Experten kennen',
            compCareers: 'Karriere',
            compCareersDesc: 'Treten Sie unserem wachsenden Team bei',
            compContactDesc: 'Kontaktieren Sie uns'
        },
        hero: {
            title1: 'China Supply Chain Partner für',
            title2: 'Cross-Border E-Commerce-Marken',
            description: 'Von der Beschaffung und Qualitätskontrolle über Lagerung, Fulfillment bis zur globalen Versandlogistik - FULFILLDROP hilft schnell wachsenden Verkäufern, stabile Operationen zu führen und sicher zu skalieren.',
            btn: 'Mit FULFILLDROP sprechen',
            trust1: 'Beschaffung + Fulfillment + Versand',
            trust2: 'Für 10-10000+ Bestellungen/Tag entwickelt',
            trust3: 'Transparente SLA & Ausnahmebehandlung'
        },
        capabilities: {
            title: 'Was wir Ihnen helfen, zu beheben',
            items: [
                { number: '01', title: 'Lieferantenstabilität', description: 'Erstellen Sie eine sicherheitskopierfähige Versorgung mit geprüften Fabriken, Ersatzoptionen und Nachschubplanung.' },
                { number: '02', title: 'Bestellverarbeitungseffizienz', description: 'Automatisieren Sie Bestellungssynchronisation und Fulfillment-Workflows, um menschliche Fehler zu reduzieren und den Versand zu beschleunigen.' },
                { number: '03', title: 'Qualität & Konsistenz', description: 'Nutzen Sie klare QC-Checkpoints und Ausnahmebehandlung, um die Kundenerfahrung bei der Skalierung zu schützen.' },
                { number: '04', title: 'Maßgeschneiderte Lieferung', description: 'Führen Sie POD/OEM/ODM-Projekte mit wiederholbarer Probenahme bis zur Produktion und Verpackungsausführung durch.' },
                { number: '05', title: 'Globale Versandzuverlässigkeit', description: 'Nutzen Sie stabile Routen und Tracking-Sichtbarkeit, um die Lieferleistung vorhersehbar zu halten.' },
                { number: '06', title: 'After-Sales-Kontrolle', description: 'Standardisieren Sie Reship/Rückerstattung-Workflows, damit die Servicequalität während des Wachstums konsistent bleibt.' }
            ]
        },
        home: {
            trusted: 'Von 100+ Cross-Border-Verkäufern empfohlen',
            operationsLive: 'Live-Operationen',
            dispatch24h: 'Innerhalb von 24h versandt',
            skuAvailable: 'SKUs zur Beschaffung verfügbar',
            integratedWith: 'Integriert mit',
            statsQuote: 'Die Zahlen erzählen die wahre Geschichte: Wir operieren im Maßstab.',
            whyChoose: 'Warum FULFILLDROP wählen',
            whySubtitle: 'Für skalierbare Operationen entwickelt',
            whyDesc: 'Wir warten nicht auf Probleme. Wir bauen Systeme, die sie verhindern.',
            why1Title: 'Proaktive Qualitätskontrolle',
            why1Desc: 'Wir identifizieren und beheben Probleme, bevor sie Ihre Kunden beeinträchtigen. Multi-Punkt-QC, Versandprüfungen und Schadensprävention sind in jede Bestellung integriert.',
            why2Title: 'Synchrone Kommunikation',
            why2Desc: 'Keine Vermutungen mehr. Holen Sie Echtzeit-Updates zu Beschaffung, Produktion und Versand - alles in einer Ansicht. Ihre Kunden erhalten schneller genaue Informationen.',
            why3Title: 'Maßgeschneiderte Flexibilität',
            why3Desc: 'POD, OEM, ODM – wir handhaben maßgeschneiderte Verpackung, Einlagen und Branding, damit Ihr Unboxing-Erlebnis Ihrem Markenversprechen entspricht.',
            industryTitle: 'Tiefe Spezialisierung in Schlüsselkategorien',
            industrySubtitle: 'Wir verstehen die einzigartigen Herausforderungen jeder Kategorie – und haben zielgerichtete Lösungen entwickelt.',
            industry1Title: 'Mode & Bekleidung',
            industry1Desc: 'Größenvarianten, Stoff-QC und maßgeschneiderte Beschriftung – wir handhaben die Komplexität der Mode-Fulfillment mit Präzision.',
            industry2Title: 'Gesundheitsergänzungsmittel',
            industry2Desc: 'Chargenverfolgung, Konformitätsdokumentation und zertifizierte Lagerung – für Supplement-Sicherheit und Vertrauen entwickelt.',
            industry3Title: 'Beleuchtung & Heimdekoration',
            industry3Desc: 'Protokolle für empfindliche Handhabung, Versicherungsschutz und schützende Verpackung – Ihre Produkte gelangen unversehrt.',
            statsOrders: 'Täglich verarbeitete Bestellungen',
            ctaPrimary: 'Mit Experten sprechen',
            ctaSecondary: 'Mehr über unsere Plattform erfahren',
            talkExpert: 'Mit Experten sprechen',
            viewAllSolutions: 'Alle Lösungen anzeigen',
            explorePlatform: 'Plattform erkunden',
            capEyebrow: 'Kernkompetenzen',
            solEyebrow: 'Lösungen',
            solSubtitle: 'Wählen Sie das Modell, das zu Ihrer Phase und Komplexität passt'
        },
        faq: {
            title: 'Häufig gestellte Fragen',
            description: 'Finden Sie Antworten auf häufig gestellte Fragen zu unseren Dienstleistungen',
            questions: 'Fragen',
            contactTitle: 'Noch Fragen?',
            contactText: 'Unser Team steht Ihnen zur Verfügung, um alle Ihre Fragen zu beantworten',
            contactBtn: 'Kontaktieren Sie uns',
            items: [
                {
                    category: 'Loslegen',
                    question: 'Wie beginne ich mit Ihren Fulfillment-Dienstleistungen?',
                    answer: 'Loslegen ist einfach! Melden Sie sich einfach für ein Konto an, verbinden Sie Ihren Shop und senden Sie uns Ihr Inventar. Unser Onboarding-Team begleitet Sie bei jedem Schritt.'
                },
                {
                    category: 'Loslegen',
                    question: 'Was sind die Mindestbestellvoraussetzungen?',
                    answer: 'Wir haben keine Mindestbestellvoraussetzungen! Ob Sie 10 oder 10.000 Bestellungen pro Tag versenden, wir können Ihren Bedürfnissen gerecht werden.'
                },
                {
                    category: 'Loslegen',
                    question: 'Wie lange dauert das Onboarding?',
                    answer: 'Das Onboarding dauert in der Regel 3-5 Werktage, abhängig von der Komplexität Ihres Inventars. Wir arbeiten fleißig, um Sie so schnell wie möglich in Betrieb zu nehmen.'
                },
                {
                    category: 'Preise & Gebühren',
                    question: 'Wie sind Ihre Preise strukturiert?',
                    answer: 'Unsere Preise sind transparent und basieren auf Pick-Pack-Ship-Gebühren plus Lagerung. Wir bieten Mengenrabatte für Hochvolumen-Verkäufer. Kontaktieren Sie uns für ein individuelles Angebot.'
                },
                {
                    category: 'Preise & Gebühren',
                    question: 'Gibt es versteckte Gebühren?',
                    answer: 'Keine versteckten Gebühren! Alle unsere Gebühren sind in Ihrem Vertrag klar festgelegt. Wir glauben an transparente Preisgestaltung, damit Sie effektiv budgetieren können.'
                },
                {
                    category: 'Preise & Gebühren',
                    question: 'Bieten Sie Mengenrabatte?',
                    answer: 'Ja! Wir bieten stufenweise Mengenrabatte, die automatisch angewendet werden, wenn Ihr Bestellvolumen zunimmt. Je mehr Sie versenden, desto mehr sparen Sie.'
                },
                {
                    category: 'Inventarverwaltung',
                    question: 'Wie sende ich Inventar an Ihr Lager?',
                    answer: 'Wir können direkt mit Ihren Lieferanten koordinieren, oder Sie können das Inventar mit jedem Transporteur an unser Lager senden. Wir stellen detaillierte Empfangsanweisungen zur Verfügung.'
                },
                {
                    category: 'Inventarverwaltung',
                    question: 'Kann ich mein Inventar in Echtzeit verfolgen?',
                    answer: 'Absolut! Unsere Dashboard bietet Echtzeit-Bestandsverfolgung, einschließlich Lagerbeständen, eingehender Sendungen und Bestellstatus.'
                },
                {
                    category: 'Inventarverwaltung',
                    question: 'Was passiert, wenn das Inventar knapp wird?',
                    answer: 'Unser System sendet automatisch Warnungen bei niedrigem Lagerbestand, und unser Team benachrichtigt Sie proaktiv, um sicherzustellen, dass Sie nie beliebte Artikel ausverkaufen.'
                },
                {
                    category: 'Versand & Lieferung',
                    question: 'Mit welchen Transporteuren arbeiten Sie?',
                    answer: 'Wir arbeiten mit allen großen Transporteuren zusammen, darunter FedEx, UPS, DHL, USPS und Regionaltransporteuren, um die besten Tarife und Lieferzeiten zu gewährleisten.'
                },
                {
                    category: 'Versand & Lieferung',
                    question: 'Bieten Sie internationalen Versand an?',
                    answer: 'Ja! Wir versenden an über 150 Länder weltweit mit optimierten internationalen Versandrouten und Zollabfertigungsunterstützung.'
                },
                {
                    category: 'Versand & Lieferung',
                    question: 'Was ist Ihre durchschnittliche Lieferzeit?',
                    answer: 'Inländische Bestellungen werden normalerweise innerhalb von 2-5 Werktagen geliefert, während internationale Bestellungen je nach Zielland 5-14 Werktage dauern.'
                },
                {
                    category: 'Retouren & Austausch',
                    question: 'Wie funktionieren Retouren?',
                    answer: 'Wir handhaben Retouren in Ihrem Namen! Kunden senden Retouren an unser Lager, wir prüfen sie und aktualisieren Ihr Inventar entsprechend.'
                },
                {
                    category: 'Retouren & Austausch',
                    question: 'Können Sie Austäusche verarbeiten?',
                    answer: 'Ja, wir können den gesamten Austauschprozess verwalten, einschließlich Prüfung, Nachschub und Versand von Ersatzartikeln an Ihre Kunden.'
                },
                {
                    category: 'Retouren & Austausch',
                    question: 'Wie lange dauert die Retourenverarbeitung?',
                    answer: 'Retouren werden normalerweise innerhalb von 24-48 Stunden nach Erhalt verarbeitet, und Ihr Inventar wird sofort in unserem System aktualisiert.'
                },
                {
                    category: 'Maßgeschneiderte Lösungen',
                    question: 'Können Sie maßgeschneiderte Verpackung verarbeiten?',
                    answer: 'Absolut! Wir bieten maßgeschneiderte Verpackung, Markeneinlagen, Geschenkverpackung und spezielle Präsentationsdienste, um Ihre Marke zu heben.'
                },
                {
                    category: 'Maßgeschneiderte Lösungen',
                    question: 'Unterstützen Sie Kitting und Montage?',
                    answer: 'Ja! Wir bieten Kitting-, Montage-, Bundling- und Produktanpassungsdienste, um einzigartige Produktkombinationen zu erstellen.'
                },
                {
                    category: 'Maßgeschneiderte Lösungen',
                    question: 'Können Sie sich mit meiner Plattform integrieren?',
                    answer: 'Wir integrieren uns mit allen großen E-Commerce-Plattformen, darunter Shopify, WooCommerce, BigCommerce, Magento und mehr. Kontaktieren Sie uns für maßgeschneiderte Integrationen!'
                }
            ]
        },
        footer: {
            about: 'Über Uns',
            company: 'Unternehmensprofil',
            team: 'Teammitglieder',
            news: 'Nachrichten',
            careers: 'Karriere',
            solutions: 'Lösungen',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistik',
            custom: 'Maßgeschneiderte Lösungen',
            support: 'Support',
            help: 'Hilfecenter',
            faq: 'FAQ',
            contact: 'Kontakt',
            privacy: 'Datenschutzrichtlinie',
            contactInfo: 'Kontaktinformationen',
            email: 'E-Mail: 270302301@qq.com',
            phone: 'Telefon: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 FULFILLDROP Cross-Border E-Commerce Plattform. Alle Rechte vorbehalten.'
        }
    },
    pt: {
        nav: {
            home: 'Início',
            solutions: 'Soluções',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logística',
            products: 'Produtos',
            platform: 'Plataforma',
            pricing: 'Preços',
            faq: 'FAQ',
            about: 'Sobre Nós',
            contact: 'Contato',
            getStarted: 'Começar',
            resources: 'Recursos'
        },
        megamenu: {
            solByType: 'Por Tipo',
            solPopular: 'Popular',
            solMostPopular: 'Mais Popular',
            solBrandedPackaging: 'Embalagem de Marca',
            solBrandedPackagingDesc: 'Embalagem personalizada, inserts e experiência de desembalagem',
            solExplore: 'Explorar',
            solNew: 'Novo',
            solAPI: 'Integração API',
            solAPIDesc: 'Acesso completo à API para integração perfeita',
            solLearnMore: 'Saiba Mais',
            platCoreFeatures: 'Funcionalidades Principais',
            platOrderMgmt: 'Gerenciamento de Pedidos',
            platInventory: 'Controle de Estoque',
            platInventoryDesc: 'Acompanhamento e alertas de estoque em tempo real',
            platQC: 'Controle de Qualidade',
            platQCDesc: 'Processo de inspeção em múltiplas etapas',
            platAnalytics: 'Análise e Relatórios',
            platAnalyticsDesc: 'Análise abrangente de desempenho',
            platIntegrations: 'Integrações',
            platShopify: 'Shopify',
            platShopifyDesc: 'Integração perfeita com loja Shopify',
            platTikTokDesc: 'Integração de fulfillment do TikTok Shop',
            platWoo: 'WooCommerce',
            platWooDesc: 'Suporte à integração WooCommerce',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: 'Tecnologia',
            platREST: 'REST API',
            platRESTDesc: 'API RESTful completa para desenvolvimento personalizado',
            platWebhooksDesc: 'Notificações de webhook em tempo real',
            platSecurity: 'Segurança',
            platSecurityDesc: 'Medidas de segurança empresariais',
            platTracking: 'Acompanhamento',
            platTrackingDesc: 'Acompanhamento de pacotes em tempo real',
            resHelpCenter: 'Centro de Ajuda',
            resGuides: 'Guias',
            resGuidesDesc: 'Guias detalhados de configuração e otimização',
            resVideoDemos: 'Demonstrações em Vídeo',
            resVideoDemosDesc: 'Tutoriais visuais e walkthroughs',
            resInsights: 'Insights',
            resBlog: 'Blog',
            resCaseStudies: 'Estudos de Caso',
            resCaseStudiesDesc: 'Histórias de sucesso reais de nossos clientes',
            resEbooks: 'Ebooks',
            resEbooksDesc: 'Relatórios e guias profundos do setor',
            resDevelopers: 'Desenvolvedores',
            resAPIDocs: 'Documentação da API',
            resAPIDocsDesc: 'Documentação completa da API',
            resIntegration: 'Integração',
            resIntegrationDesc: 'Guias e ferramentas de integração',
            resStatus: 'Status',
            compAbout: 'Sobre Nós',
            compTeam: 'Nossa Equipe',
            compTeamDesc: 'Conheça os membros da nossa equipe especializada',
            compCareers: 'Carreiras',
            compCareersDesc: 'Junte-se à nossa equipe em crescimento',
            compContactDesc: 'Entre em contato conosco'
        },
        hero: {
            title1: 'Parceiro de Supply Chain Chinês para',
            title2: 'Marcas de E-commerce Transfronteiriço',
            description: 'Desde a fonte e controle de qualidade até o armazenamento, fulfillment e envio global, a FULFILLDROP ajuda vendedores em rápido crescimento a operar de forma estável e escalar com confiança.',
            btn: 'Fale com a FULFILLDROP',
            trust1: 'Fonte + Fulfillment + Envio',
            trust2: 'Desenvolvido para 10-10000+ pedidos/dia',
            trust3: 'SLA transparente e tratamento de exceções'
        },
        capabilities: {
            title: 'O que nós ajudamos a resolver',
            items: [
                { number: '01', title: 'Estabilidade de Fornecedores', description: 'Crie um suprimento com backup com fábricas validadas, opções de substituição e planejamento de reposição.' },
                { number: '02', title: 'Eficiência no Processamento de Pedidos', description: 'Automatize a sincronização de pedidos e fluxos de trabalho de fulfillment para reduzir erros manuais e acelerar o envio.' },
                { number: '03', title: 'Qualidade e Consistência', description: 'Use pontos de verificação claros de QC e tratamento de exceções para proteger a experiência do cliente na escala.' },
                { number: '04', title: 'Entrega Personalizada', description: 'Execute projetos POD/OEM/ODM com amostragem repetível até produção e execução de embalagem.' },
                { number: '05', title: 'Confiabilidade no Envio Global', description: 'Aproveite rotas estáveis e visibilidade de acompanhamento para manter o desempenho de entrega previsível.' },
                { number: '06', title: 'Controle Pós-Venda', description: 'Padronize fluxos de trabalho de reenvio/reembolso para manter a qualidade do serviço consistente durante o crescimento.' }
            ]
        },
        home: {
            trusted: 'Recomendado por 100+ vendedores transfronteiriços',
            operationsLive: 'Operações ao Vivo',
            dispatch24h: 'Pedidos enviados em 24h',
            skuAvailable: 'SKUs Disponíveis para Fonte',
            integratedWith: 'Integrado com',
            statsQuote: 'Os números contam a história real: operamos em escala.',
            whyChoose: 'Por Que Escolher a FULFILLDROP',
            whySubtitle: 'Desenvolvido para operações que escalam',
            whyDesc: 'Não esperamos que os problemas apareçam. Criamos sistemas que os evitam.',
            why1Title: 'Controle de Qualidade Proativo',
            why1Desc: 'Identificamos e resolvemos problemas antes que eles afetem seus clientes. QC multiponto, verificações pré-envio e prevenção de danos estão integrados em cada pedido.',
            why2Title: 'Comunicação Sincronizada',
            why2Desc: 'Não adivinhe mais. Obtenha atualizações em tempo real sobre fonte, produção e envio - tudo em uma única visualização. Seus clientes recebem informações precisas mais rápido.',
            why3Title: 'Flexibilidade Personalizada',
            why3Desc: 'POD, OEM, ODM – tratamos embalagem personalizada, inserts e marca para que sua experiência de desembalagem corresponda à sua promessa de marca.',
            industryTitle: 'Especialização Profunda em Categorias Chave',
            industrySubtitle: 'Entendemos os desafios únicos de cada categoria – e criamos soluções direcionadas.',
            industry1Title: 'Moda e Vestuário',
            industry1Desc: 'Variantes de tamanho, QC de tecido e rótulos personalizados – tratamos a complexidade do fulfillment de moda com precisão.',
            industry2Title: 'Suplementos de Saúde',
            industry2Desc: 'Acompanhamento de lote, documentação de conformidade e armazenamento certificado – criado para segurança e confiança nos suplementos.',
            industry3Title: 'Iluminação e Decoração Residencial',
            industry3Desc: 'Protocolos de manipulação delicada, cobertura de seguro e embalagem protetora – seus produtos chegam intactos.',
            statsOrders: 'Pedidos Processados Diariamente',
            ctaPrimary: 'Fale com um Especialista',
            ctaSecondary: 'Saiba Mais Sobre Nossa Plataforma',
            talkExpert: 'Fale com um Especialista',
            viewAllSolutions: 'Ver Todas as Soluções',
            explorePlatform: 'Explore a Plataforma',
            capEyebrow: 'Capacidades Centrais',
            solEyebrow: 'Soluções',
            solSubtitle: 'Escolha o modelo que corresponde ao seu estágio e complexidade'
        },
        faq: {
            title: 'Perguntas Frequentes',
            description: 'Encontre respostas para perguntas comuns sobre nossos serviços',
            questions: 'Perguntas',
            contactTitle: 'Ainda tem perguntas?',
            contactText: 'Nossa equipe está aqui para ajudar com qualquer pergunta que você possa ter',
            contactBtn: 'Entre em Contato',
            items: [
                {
                    category: 'Começar',
                    question: 'Como começar com seus serviços de fulfillment?',
                    answer: 'Começar é fácil! Basta se inscrever em uma conta, conectar sua loja e enviar nosso estoque. Nossa equipe de onboarding irá guiá-lo em cada etapa.'
                },
                {
                    category: 'Começar',
                    question: 'Quais são os requisitos mínimos de pedido?',
                    answer: 'Não temos requisitos mínimos de pedido! Seja enviando 10 pedidos por dia ou 10.000, podemos atender às suas necessidades.'
                },
                {
                    category: 'Começar',
                    question: 'Quanto tempo leva o onboarding?',
                    answer: 'O onboarding geralmente leva 3-5 dias úteis, dependendo da complexidade do seu estoque. Trabalhamos diligentemente para colocá-lo em operação o mais rápido possível.'
                },
                {
                    category: 'Preços e Taxas',
                    question: 'Como é estruturada sua precificação?',
                    answer: 'Nossa precificação é transparente e baseada em taxas de pick-pack-ship mais armazenamento. Oferecemos descontos por volume para vendedores de alto volume. Contate-nos para um orçamento personalizado.'
                },
                {
                    category: 'Preços e Taxas',
                    question: 'Existem taxas ocultas?',
                    answer: 'Não há taxas ocultas! Todas as nossas cobranças estão claramente descritas em seu contrato. Acreditamos em precificação transparente para que você possa orçar efetivamente.'
                },
                {
                    category: 'Preços e Taxas',
                    question: 'Vocês oferecem descontos por volume?',
                    answer: 'Sim! Oferecemos descontos por volume em níveis que são aplicados automaticamente à medida que seu volume de pedidos aumenta. Quanto mais você envia, mais economiza.'
                },
                {
                    category: 'Gerenciamento de Estoque',
                    question: 'Como envio estoque para seu armazém?',
                    answer: 'Podemos coordenar diretamente com seus fornecedores, ou você pode enviar estoque para nosso armazém usando qualquer transportador. Fornecemos instruções detalhadas de recebimento.'
                },
                {
                    category: 'Gerenciamento de Estoque',
                    question: 'Posso acompanhar meu estoque em tempo real?',
                    answer: 'Absolutamente! Nosso painel fornece acompanhamento de estoque em tempo real, incluindo níveis de estoque, remessas recebidas e status de pedidos.'
                },
                {
                    category: 'Gerenciamento de Estoque',
                    question: 'O que acontece se o estoque ficar baixo?',
                    answer: 'Nosso sistema envia automaticamente alertas de estoque baixo, e nossa equipe notificará você proativamente para garantir que você nunca fique sem itens populares.'
                },
                {
                    category: 'Envio e Entrega',
                    question: 'Com quais transportadoras vocês trabalham?',
                    answer: 'Trabalhamos com todas as principais transportadoras, incluindo FedEx, UPS, DHL, USPS e transportadoras regionais para garantir as melhores taxas e tempos de entrega.'
                },
                {
                    category: 'Envio e Entrega',
                    question: 'Vocês oferecem envio internacional?',
                    answer: 'Sim! Enviamos para mais de 150 países em todo o mundo com rotas de envio internacional otimizadas e suporte a desembaraço aduaneiro.'
                },
                {
                    category: 'Envio e Entrega',
                    question: 'Qual é o seu tempo médio de entrega?',
                    answer: 'Pedidos domésticos geralmente são entregues em 2-5 dias úteis, enquanto pedidos internacionais levam 5-14 dias úteis dependendo do destino.'
                },
                {
                    category: 'Devoluções e Trocas',
                    question: 'Como funcionam as devoluções?',
                    answer: 'Tratamos as devoluções em seu nome! Os clientes enviam devoluções para nosso armazém, nós as inspecionamos e atualizamos seu estoque de acordo.'
                },
                {
                    category: 'Devoluções e Trocas',
                    question: 'Vocês podem lidar com trocas?',
                    answer: 'Sim, podemos gerenciar todo o processo de troca, incluindo inspeção, reposição e envio de itens de substituição para seus clientes.'
                },
                {
                    category: 'Devoluções e Trocas',
                    question: 'Qual é o tempo de processamento de devoluções?',
                    answer: 'As devoluções geralmente são processadas dentro de 24-48 horas após o recebimento, e seu estoque é atualizado imediatamente em nosso sistema.'
                },
                {
                    category: 'Soluções Personalizadas',
                    question: 'Vocês podem lidar com embalagem personalizada?',
                    answer: 'Absolutamente! Oferecemos embalagem personalizada, inserts de marca, embalagem de presente e serviços especiais de apresentação para elevar sua marca.'
                },
                {
                    category: 'Soluções Personalizadas',
                    question: 'Vocês suportam kitting e montagem?',
                    answer: 'Sim! Oferecemos serviços de kitting, montagem, agrupamento e personalização de produtos para criar combinações de produtos exclusivas.'
                },
                {
                    category: 'Soluções Personalizadas',
                    question: 'Vocês podem se integrar com minha plataforma?',
                    answer: 'Integramos com todas as principais plataformas de e-commerce, incluindo Shopify, WooCommerce, BigCommerce, Magento e mais. Contate-nos sobre integrações personalizadas!'
                }
            ]
        },
        footer: {
            about: 'Sobre Nós',
            company: 'Perfil da Empresa',
            team: 'Membros da Equipe',
            news: 'Notícias',
            careers: 'Carreiras',
            solutions: 'Soluções',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logística',
            custom: 'Soluções Personalizadas',
            support: 'Suporte',
            help: 'Centro de Ajuda',
            faq: 'FAQ',
            contact: 'Contato',
            privacy: 'Política de Privacidade',
            contactInfo: 'Informações de Contato',
            email: 'E-mail: 270302301@qq.com',
            phone: 'Telefone: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 FULFILLDROP Plataforma de E-commerce Transfronteiriço. Todos os direitos reservados.'
        }
    },
    it: {
        nav: {
            home: 'Home',
            solutions: 'Soluzioni',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistica',
            products: 'Prodotti',
            platform: 'Piattaforma',
            pricing: 'Prezzi',
            faq: 'FAQ',
            about: 'About Us',
            contact: 'Contatto',
            getStarted: 'Inizia',
            resources: 'Risorse'
        },
        megamenu: {
            solByType: 'Per Tipo',
            solPopular: 'Popolare',
            solMostPopular: 'Più Popolare',
            solBrandedPackaging: 'Imballaggio Marchiato',
            solBrandedPackagingDesc: 'Imballaggi personalizzati, inserti e esperienza di unboxing',
            solExplore: 'Esplora',
            solNew: 'Nuovo',
            solAPI: 'Integrazione API',
            solAPIDesc: 'Accesso completo all\'API per un\'integrazione fluida',
            solLearnMore: 'Scopri di Più',
            platCoreFeatures: 'Funzionalità Core',
            platOrderMgmt: 'Gestione Ordini',
            platInventory: 'Controllo Inventario',
            platInventoryDesc: 'Tracciamento e avvisi di inventario in tempo reale',
            platQC: 'Controllo Qualità',
            platQCDesc: 'Processo di ispezione in più fasi',
            platAnalytics: 'Analitiche e Report',
            platAnalyticsDesc: 'Analisi complete delle prestazioni',
            platIntegrations: 'Integrazioni',
            platShopify: 'Shopify',
            platShopifyDesc: 'Integrazione fluida con il negozio Shopify',
            platTikTokDesc: 'Integrazione fulfillment TikTok Shop',
            platWoo: 'WooCommerce',
            platWooDesc: 'Supporto per l\'integrazione WooCommerce',
            platAmazon: 'Amazon',
            platTikTok: 'TikTok',
            platTechnology: 'Tecnologia',
            platREST: 'REST API',
            platRESTDesc: 'API RESTful completa per lo sviluppo personalizzato',
            platWebhooksDesc: 'Notifiche webhook in tempo reale',
            platSecurity: 'Sicurezza',
            platSecurityDesc: 'Misure di sicurezza a livello enterprise',
            platTracking: 'Tracciamento',
            platTrackingDesc: 'Tracciamento pacchi in tempo reale',
            resHelpCenter: 'Centro Aiuto',
            resGuides: 'Guide',
            resGuidesDesc: 'Guide dettagliate per la configurazione e l\'ottimizzazione',
            resVideoDemos: 'Demo Video',
            resVideoDemosDesc: 'Tutorial visivi e walkthrough',
            resInsights: 'Insights',
            resBlog: 'Blog',
            resCaseStudies: 'Casi Studio',
            resCaseStudiesDesc: 'Storie di successo reali dei nostri clienti',
            resEbooks: 'Ebook',
            resEbooksDesc: 'Report e guide approfondite del settore',
            resDevelopers: 'Sviluppatori',
            resAPIDocs: 'Documentazione API',
            resAPIDocsDesc: 'Documentazione completa dell\'API',
            resIntegration: 'Integrazione',
            resIntegrationDesc: 'Guide e strumenti per l\'integrazione',
            resStatus: 'Stato',
            compAbout: 'About Us',
            compTeam: 'Il Nostro Team',
            compTeamDesc: 'Conosci i membri del nostro team di esperti',
            compCareers: 'Carriere',
            compCareersDesc: 'Unisciti al nostro team in crescita',
            compContactDesc: 'Contattaci'
        },
        hero: {
            title1: 'Partner della Catena di Fornitura Cinese per',
            title2: 'Marchi di E-commerce Transfrontalieri',
            description: 'Dalla fornitura e controllo qualità all\'immagazzinamento, fulfillment e spedizione globale, FULFILLDROP aiuta i venditori in rapida crescita a gestire operazioni stabili e scalare con fiducia.',
            btn: 'Parla con FULFILLDROP',
            trust1: 'Fornitura + Fulfillment + Spedizione',
            trust2: 'Realizzato per 10-10000+ ordini/giorno',
            trust3: 'SLA trasparente e gestione eccezioni'
        },
        capabilities: {
            title: 'Cosa Aiutiamo a Risolvere',
            items: [
                { number: '01', title: 'Stabilità Fornitori', description: 'Crea un approvvigionamento con backup con fabbriche verificate, opzioni di sostituzione e pianificazione del rifornimento.' },
                { number: '02', title: 'Efficienza Processamento Ordini', description: 'Automatizza la sincronizzazione ordini e i flussi di lavoro di fulfillment per ridurre errori manuali e accelerare le spedizioni.' },
                { number: '03', title: 'Qualità e Consistenza', description: 'Usa punti di controllo QC chiari e gestione eccezioni per proteggere l\'esperienza cliente alla scala.' },
                { number: '04', title: 'Consegna Personalizzata', description: 'Esegui progetti POD/OEM/ODM con campionamento ripetibile fino alla produzione e esecuzione dell\'imballaggio.' },
                { number: '05', title: 'Affidabilità Spedizione Globale', description: 'Sfrutta rotte stabili e visibilità di tracciamento per mantenere le prestazioni di consegna prevedibili.' },
                { number: '06', title: 'Controllo Post-Vendita', description: 'Standardizza i flussi di lavoro di re-spedizione/rimborso per mantenere la qualità del servizio costante durante la crescita.' }
            ]
        },
        home: {
            trusted: 'Consigliato da oltre 100 venditori transfrontalieri',
            operationsLive: 'Operazioni Live',
            dispatch24h: 'Ordini spediti in 24h',
            skuAvailable: 'SKU Disponibili per l\'Approvvigionamento',
            integratedWith: 'Integrato con',
            statsQuote: 'I numeri raccontano la storia vera: operiamo su larga scala.',
            whyChoose: 'Perché Scegliere FULFILLDROP',
            whySubtitle: 'Realizzato per operazioni che si espandono',
            whyDesc: 'Non aspettiamo che i problemi compaiano. Costruiamo sistemi che li prevengono.',
            why1Title: 'Controllo Qualità Proattivo',
            why1Desc: 'Identifichiamo e risolviamo i problemi prima che influenzino i tuoi clienti. QC multipunto, controlli pre-spedizione e prevenzione danni sono integrati in ogni ordine.',
            why2Title: 'Comunicazione Sincronizzata',
            why2Desc: 'Non indovinare più. Ottieni aggiornamenti in tempo reale su approvvigionamento, produzione e spedizione - tutto in un\'unica vista. I tuoi clienti ricevono informazioni accurate più velocemente.',
            why3Title: 'Flessibilità Personalizzata',
            why3Desc: 'POD, OEM, ODM – gestiamo imballaggi personalizzati, inserti e marchiatura affinché l\'esperienza di unboxing corrisponda alla promessa del tuo marchio.',
            industryTitle: 'Specializzazione Profonda in Categorie Chiave',
            industrySubtitle: 'Capiamo le sfide uniche di ogni categoria – e abbiamo creato soluzioni mirate.',
            industry1Title: 'Moda e Abbigliamento',
            industry1Desc: 'Varianti di taglia, QC tessile e etichette personalizzate – gestiamo la complessità del fulfillment moda con precisione.',
            industry2Title: 'Integratori di Salute',
            industry2Desc: 'Tracciamento lotto, documentazione di conformità e archiviazione certificata – creato per sicurezza e fiducia negli integratori.',
            industry3Title: 'Illuminazione e Arredamento Casa',
            industry3Desc: 'Protocolli di manipolazione delicata, copertura assicurativa e imballaggio protettivo – i tuoi prodotti arrivano intatti.',
            statsOrders: 'Ordini Processati Giornalmente',
            ctaPrimary: 'Parla con un Esperto',
            ctaSecondary: 'Scopri di Più sulla Nostra Piattaforma',
            talkExpert: 'Parla con un Esperto',
            viewAllSolutions: 'Visualizza Tutte le Soluzioni',
            explorePlatform: 'Esplora la Piattaforma',
            capEyebrow: 'Capacità Core',
            solEyebrow: 'Soluzioni',
            solSubtitle: 'Scegli il modello che corrisponde alla tua fase e complessità'
        },
        faq: {
            title: 'Domande Frequenti',
            description: 'Trova risposte alle domande comuni sui nostri servizi',
            questions: 'Domande',
            contactTitle: 'Ancora domande?',
            contactText: 'Il nostro team è qui per aiutarti con qualsiasi domanda che tu possa avere',
            contactBtn: 'Contattaci',
            items: [
                {
                    category: 'Iniziare',
                    question: 'Come posso iniziare con i servizi di fulfillment?',
                    answer: 'Iniziare è facile! Basta registrarsi a un account, collegare il tuo negozio e inviare il nostro inventario. Il nostro team di onboarding ti guiderà in ogni passaggio.'
                },
                {
                    category: 'Iniziare',
                    question: 'Quali sono i requisiti minimi di ordine?',
                    answer: 'Non abbiamo requisiti minimi di ordine! Che tu spedisca 10 ordini al giorno o 10.000, possiamo soddisfare le tue esigenze.'
                },
                {
                    category: 'Iniziare',
                    question: 'Quanto tempo ci vuole per l\'onboarding?',
                    answer: 'L\'onboarding richiede in genere 3-5 giorni lavorativi, a seconda della complessità del tuo inventario. Lavoriamo diligentemente per metterti in funzione il più velocemente possibile.'
                },
                {
                    category: 'Prezzi e Tariffe',
                    question: 'Come sono strutturati i prezzi?',
                    answer: 'I nostri prezzi sono trasparenti e basati su tariffe pick-pack-ship più immagazzinamento. Offriamo sconti per volume ai venditori ad alto volume. Contattaci per un preventivo personalizzato.'
                },
                {
                    category: 'Prezzi e Tariffe',
                    question: 'Ci sono tariffe nascoste?',
                    answer: 'Nessuna tariffa nascosta! Tutte le nostre spese sono chiaramente indicate nel tuo contratto. Crediamo in una tariffazione trasparente per permetterti di budgetizzare efficacemente.'
                },
                {
                    category: 'Prezzi e Tariffe',
                    question: 'Offrite sconti per volume?',
                    answer: 'Sì! Offriamo sconti per volume a livelli che si applicano automaticamente man mano che il tuo volume di ordini aumenta. Più spedisci, più risparmi.'
                },
                {
                    category: 'Gestione Inventario',
                    question: 'Come invio l\'inventario al tuo magazzino?',
                    answer: 'Possiamo coordinarci direttamente con i tuoi fornitori, o puoi inviare l\'inventario al nostro magazzino utilizzando qualsiasi corriere. Forniamo istruzioni dettagliate per la ricezione.'
                },
                {
                    category: 'Gestione Inventario',
                    question: 'Posso tracciare il mio inventario in tempo reale?',
                    answer: 'Assolutamente! Il nostro dashboard fornisce tracciamento dell\'inventario in tempo reale, inclusi i livelli di stock, le spedizioni in arrivo e lo stato degli ordini.'
                },
                {
                    category: 'Gestione Inventario',
                    question: 'Cosa succede se l\'inventario scende a livelli bassi?',
                    answer: 'Il nostro sistema invia automaticamente avvisi di stock basso, e il nostro team ti notificherà proattivamente per garantire che non ti rimarrai mai senza articoli popolari.'
                },
                {
                    category: 'Spedizione e Consegna',
                    question: 'Con quali corrieri lavorate?',
                    answer: 'Collaboriamo con tutti i principali corrieri, tra cui FedEx, UPS, DHL, USPS e corrieri regionali per garantire le migliori tariffe e tempi di consegna.'
                },
                {
                    category: 'Spedizione e Consegna',
                    question: 'Offrite spedizioni internazionali?',
                    answer: 'Sì! Spediamo in oltre 150 paesi in tutto il mondo con rotte di spedizione internazionale ottimizzate e supporto per la dogana.'
                },
                {
                    category: 'Spedizione e Consegna',
                    question: 'Qual è il tempo medio di consegna?',
                    answer: 'Gli ordini nazionali vengono solitamente consegnati in 2-5 giorni lavorativi, mentre gli ordini internazionali richiedono 5-14 giorni lavorativi a seconda della destinazione.'
                },
                {
                    category: 'Resi e Scambi',
                    question: 'Come funzionano i resi?',
                    answer: 'Gestiamo i resi per tuo conto! I clienti inviano i resi al nostro magazzino, li ispezioniamo e aggiorniamo il tuo inventario di conseguenza.'
                },
                {
                    category: 'Resi e Scambi',
                    question: 'Potete gestire gli scambi?',
                    answer: 'Sì, possiamo gestire l\'intero processo di scambio, inclusa l\'ispezione, il rifornimento e la spedizione di articoli di ricambio ai tuoi clienti.'
                },
                {
                    category: 'Resi e Scambi',
                    question: 'Qual è il tempo di elaborazione dei resi?',
                    answer: 'I resi vengono solitamente elaborati entro 24-48 ore dalla ricezione, e il tuo inventario viene aggiornato immediatamente nel nostro sistema.'
                },
                {
                    category: 'Soluzioni Personalizzate',
                    question: 'Potete gestire imballaggi personalizzati?',
                    answer: 'Assolutamente! Offriamo imballaggi personalizzati, inserti di marchio, confezioni regalo e servizi speciali di presentazione per elevare il tuo marchio.'
                },
                {
                    category: 'Soluzioni Personalizzate',
                    question: 'Supportate kitting e assemblaggio?',
                    answer: 'Sì! Offriamo servizi di kitting, assemblaggio, bundling e personalizzazione prodotti per creare combinazioni di prodotti uniche.'
                },
                {
                    category: 'Soluzioni Personalizzate',
                    question: 'Potete integrarvi con la mia piattaforma?',
                    answer: 'Ci integriamo con tutte le principali piattaforme di e-commerce, tra cui Shopify, WooCommerce, BigCommerce, Magento e altre. Contattaci per integrazioni personalizzate!'
                }
            ]
        },
        footer: {
            about: 'About Us',
            company: 'Profilo Aziendale',
            team: 'Membri del Team',
            news: 'Notizie',
            careers: 'Carriere',
            solutions: 'Soluzioni',
            dropshipping: 'Dropshipping',
            fulfillment: 'Fulfillment',
            logistics: 'Logistica',
            custom: 'Soluzioni Personalizzate',
            support: 'Supporto',
            help: 'Centro Aiuto',
            faq: 'FAQ',
            contact: 'Contatto',
            privacy: 'Politica di Privacy',
            contactInfo: 'Informazioni di Contatto',
            email: 'Email: 270302301@qq.com',
            phone: 'Telefono: +86 18905051115',
            whatsapp: 'WhatsApp: 0086 18905051115',
            copyright: '© 2026 FULFILLDROP Piattaforma di E-commerce Transfrontaliero. Tutti i diritti riservati.'
        }
    },
    ar: {
        nav: {
            home: 'الرئيسية',
            solutions: 'الحلول',
            dropshipping: 'دروب شيبينغ',
            fulfillment: 'الاستيفاء',
            logistics: 'اللوجستية',
            products: 'المنتجات',
            platform: 'المنصة',
            pricing: 'الأسعار',
            faq: 'الأسئلة الشائعة',
            about: 'من نحن',
            contact: 'اتصل بنا',
            getStarted: 'ابدأ الآن',
            resources: 'الموارد'
        },
        megamenu: {
            solByType: 'بحسب النوع',
            solPopular: 'الشائعة',
            solMostPopular: 'الأكثر شعبية',
            solBrandedPackaging: 'التغليف العلامة التجارية',
            solBrandedPackagingDesc: 'تغليف مخصص، إدراجات وتجربة فتح العبوة',
            solExplore: 'استكشف',
            solNew: 'جديد',
            solAPI: 'التكامل API',
            solAPIDesc: 'وصول كامل لـ API للتكامل السلس',
            solLearnMore: 'اعرف المزيد',
            platCoreFeatures: 'الميزات الأساسية',
            platOrderMgmt: 'إدارة الطلبات',
            platInventory: 'مراقبة المخزون',
            platInventoryDesc: 'تتبع المخزون في الوقت الحقيقي والإخطارات',
            platQC: 'مراقبة الجودة',
            platQCDesc: 'عملية فحص متعددة الخطوات',
            platAnalytics: 'التحليلات والتقارير',
            platAnalyticsDesc: 'تحليلات أداء شاملة',
            platIntegrations: 'التكاملات',
            platShopify: 'Shopify',
            platShopifyDesc: 'التكامل السلس مع متجر Shopify',
            platTikTokDesc: 'تكامل استيفاء متجر TikTok',
            platWoo: 'WooCommerce',
            platWooDesc: 'دعم تكامل WooCommerce',
            platAmazon: 'أمازون',
            platTikTok: 'تيك توك',
            platTechnology: 'التقنية',
            platREST: 'REST API',
            platRESTDesc: 'API RESTful الكاملة للتطوير المخصص',
            platWebhooksDesc: 'إخطارات ويب هوك في الوقت الحقيقي',
            platSecurity: 'الأمان',
            platSecurityDesc: 'إجراءات أمنية من مستوى المؤسسات',
            platTracking: 'التتبع',
            platTrackingDesc: 'تتبع الحزم في الوقت الحقيقي',
            resHelpCenter: 'مركز المساعدة',
            resGuides: 'الدليل',
            resGuidesDesc: 'دليل مفصل للتعيين والتحسين',
            resVideoDemos: 'عروض فيديو',
            resVideoDemosDesc: 'دروس تعليمية مرئية ومشاهد',
            resInsights: 'الرؤى',
            resBlog: 'المدونة',
            resCaseStudies: 'دراسات الحالة',
            resCaseStudiesDesc: 'قصص نجاح حقيقية من عملائنا',
            resEbooks: 'الكتب الإلكترونية',
            resEbooksDesc: 'تقارير ومقالات عميقة للصناعة',
            resDevelopers: 'المطورين',
            resAPIDocs: 'توثيق API',
            resAPIDocsDesc: 'توثيق API الكامل',
            resIntegration: 'التكامل',
            resIntegrationDesc: 'دليل وأدوات التكامل',
            resStatus: 'الحالة',
            compAbout: 'من نحن',
            compTeam: 'فريقنا',
            compTeamDesc: 'تعرف على أعضاء فريق الخبراء لدينا',
            compCareers: 'الوظائف',
            compCareersDesc: 'انضم إلى فريقنا النامي',
            compContactDesc: 'اتصل بنا'
        },
        hero: {
            title1: 'شريك سلسلة التوريد الصينية لـ',
            title2: 'علامات التجارة الإلكترونية العابرة للحدود',
            description: 'من التوريد ومراقبة الجودة إلى التخزين والاستيفاء والشحن العالمي، تساعد FULFILLDROP البائعين السريعو النمو على تشغيل عمليات مستقرة ومتوسعة بثقة.',
            btn: 'تحدث مع FULFILLDROP',
            trust1: 'التوريد + الاستيفاء + الشحن',
            trust2: 'مصممة لـ 10-10000+ طلب/يوم',
            trust3: 'SLA شفاف وобработка استثناءات'
        },
        capabilities: {
            title: 'ما نساعد في إصلاحه',
            items: [
                { number: '01', title: 'استقرار الموردين', description: 'أنشئ إمداداً مؤمناً مع مصانع مختارة، خيارات استبدال وخطة إعادة التزويد.' },
                { number: '02', title: 'كفاءة معالجة الطلبات', description: 'أتمت مزامنة الطلبات وتدفقات عمل الاستيفاء لتقليل الأخطاء اليدوية وتسريع الشحن.' },
                { number: '03', title: 'الجودة والاستقرار', description: 'استخدم نقاط فحص QC الواضحة ومعالجة الاستثناءات لحماية تجربة العميل على نطاق واسع.' },
                { number: '04', title: 'التسليم المخصص', description: 'قم بتنفيذ مشاريع POD/OEM/ODM مع عينات متكررة إلى الإنتاج وتنفيذ التغليف.' },
                { number: '05', title: 'موثوقية الشحن العالمي', description: 'استخدم المسارات المستقرة ورؤية التتبع للحفاظ على أداء التسليم المتوقع.' },
                { number: '06', title: 'السيطرة على ما بعد البيع', description: 'قم بمعايير تدفقات إعادة الشحن/الاسترداد حتى تظل جودة الخدمة ثابتة أثناء النمو.' }
            ]
        },
        home: {
            trusted: 'موصى به من قبل أكثر من 100 بائع عابر للحدود',
            operationsLive: 'العمليات الحية',
            dispatch24h: 'الطلبات المعروضة في 24 ساعة',
            skuAvailable: 'SKUs المتاحة للتوريد',
            integratedWith: 'متكاملة مع',
            statsQuote: 'الأرقام تحكي القصة الحقيقية: نعمل على نطاق واسع.',
            whyChoose: 'لماذا تختار FULFILLDROP',
            whySubtitle: 'مصممة للعمليات التي تتنمو',
            whyDesc: 'لا ننتظر أن تظهر المشكلات. نبني أنظمة تمنعها.',
            why1Title: 'مراقبة الجودة الاستباقية',
            why1Desc: 'نحدد ونحل المشكلات قبل أن تؤثر على عملائك. QC متعدد النقاط، فحوصات قبل الشحن ومنع الأضرار مدمجة في كل طلب.',
            why2Title: 'الاتصالات المتزامنة',
            why2Desc: 'لا تحكم على المجهول. احصل على تحديثات في الوقت الحقيقي حول التوريد والإنتاج والشحن - جميعها في عرض واحد. عملاؤك يحصلون على معلومات دقيقة أسرع.',
            why3Title: 'المرونة المخصصة',
            why3Desc: 'POD، OEM، ODM - نقوم بالتغليف المخصص والإدراجات والعلامات التجارية حتى تجربة فتح العبوة تتوافق مع وعد العلامة التجارية.',
            industryTitle: 'تخصص عميق في الفئات الرئيسية',
            industrySubtitle: 'نفهم التحديات الفريدة لكل فئة - وقد صممنا حلولًا مستهدفة.',
            industry1Title: 'الأزياء والملابس',
            industry1Desc: 'الاختلافات الحجم، مراقبة الجودة للنسيج والملصقات المخصصة - نقوم بمعالجة تعقيد استيفاء الأزياء بدقة.',
            industry2Title: 'مكملات الصحة',
            industry2Desc: 'تتبع الدفعة، توثيق الامتثال والتخزين المعتمد - مصمم لأمان ومصداقية المكملات.',
            industry3Title: 'الإضاءة وتزيين المنزل',
            industry3Desc: 'بروتوكولات التعامل الحساسة، تغطية التأمين والتغليف الواقي - منتجاتك تصل سليمة.',
            statsOrders: 'الطلبات المعالجة يوميًا',
            ctaPrimary: 'تحدث مع خبير',
            ctaSecondary: 'اعرف المزيد عن منصتنا',
            talkExpert: 'تحدث مع خبير',
            viewAllSolutions: 'عرض جميع الحلول',
            explorePlatform: 'استكشف المنصة',
            capEyebrow: 'القدرات الأساسية',
            solEyebrow: 'الحلول',
            solSubtitle: 'اختر النموذج الذي يتناسب مع مرحلةك ومعقدتك'
        },
        faq: {
            title: 'الأسئلة الشائعة',
            description: 'اكتشف إجابات الأسئلة الشائعة حول خدماتنا',
            questions: 'أسئلة',
            contactTitle: 'لا تزال لديك أسئلة؟',
            contactText: 'فريقنا هنا لمساعدتك في أي سؤال قد يكون لديه',
            contactBtn: 'اتصل بنا',
            items: [
                {
                    category: 'البدء',
                    question: 'كيف أبدأ باستخدام خدمات الاستيفاء؟',
                    answer: 'البدء سهل! ما عليك سوى التسجيل في حساب، ربط متجرك وإرسال مخزوننا. فريق التشغيل لدينا سيساعدك في كل خطوة.'
                },
                {
                    category: 'البدء',
                    question: 'ما هي متطلبات الطلب الدنيا؟',
                    answer: 'لا توجد متطلبات طلبيات دنيا! سواء كنت ترسل 10 طلبات في اليوم أو 10,000، يمكننا تلبية احتياجاتك.'
                },
                {
                    category: 'البدء',
                    question: 'كم يستغرق التشغيل؟',
                    answer: 'عادةً يستغرق التشغيل 3-5 أيام عمل، حسب تعقيد مخزونك. نعمل بجد لجعلك تعمل بأسرع وقت ممكن.'
                },
                {
                    category: 'الأسعار والرسوم',
                    question: 'كيف هي هيكل الأسعار؟',
                    answer: 'أسعارنا شفافة ومقاسة على رسوم pick-pack-ship بالإضافة إلى التخزين. نقدم خصومات حجمية للبائعين عاليي الحجم. اتصل بنا للحصول على عرض مخصص.'
                },
                {
                    category: 'الأسعار والرسوم',
                    question: 'هل هناك رسوم خفية؟',
                    answer: 'لا توجد رسوم خفية! جميع رسوماتنا موضحة بوضوح في عقدك. نؤمن بالتسعير الشفاف حتى تتمكن من التخطيط المالي بكفاءة.'
                },
                {
                    category: 'الأسعار والرسوم',
                    question: 'هل تقدم خصومات حجمية؟',
                    answer: 'نعم! نقدم خصومات حجمية تتراقص وتطبق تلقائيًا مع زيادة حجم الطلبات. كلما زادت شحناتك، زادت وفوراتك.'
                },
                {
                    category: 'إدارة المخزون',
                    question: 'كيف أرسل المخزون إلى مستودعك؟',
                    answer: 'يمكننا التنسيق مباشرة مع مورديك، أو يمكنك إرسال المخزون إلى مستودعنا باستخدام أي شركة شحن. نوفر تعليمات مفصلة للإستلام.'
                },
                {
                    category: 'إدارة المخزون',
                    question: 'هل أستطيع متابعة مخزوني في الوقت الحقيقي؟',
                    answer: 'بالتأكيد! لوحة التحكم لدينا توفر متابعة المخزون في الوقت الحقيقي، بما في ذلك مستويات المخزون والشحنات الواردة وحالة الطلبات.'
                },
                {
                    category: 'إدارة المخزون',
                    question: 'ماذا يحدث إذا انخفض المخزون؟',
                    answer: 'نظامنا يرسل تلقائيًا إخطارات انخفاض المخزون، وفريقنا سيقوم بإعلامك بشكل استباقي لضمان عدم نفاد المنتجات الشائعة أبدًا.'
                },
                {
                    category: 'الشحن والتسليم',
                    question: 'مع أي شركات شحن تعمل؟',
                    answer: 'نعمل مع جميع شركات الشحن الرئيسية، بما في ذلك FedEx، UPS، DHL، USPS وشركات شحن إقليمية لضمان أفضل الأسعار وأوقات التسليم.'
                },
                {
                    category: 'الشحن والتسليم',
                    question: 'هل تقدم شحن دولي؟',
                    answer: 'نعم! نرسل إلى أكثر من 150 دولة حول العالم مع مسارات شحن دولية مُحسنة ودعم إجراءات الجمارك.'
                },
                {
                    category: 'الشحن والتسليم',
                    question: 'ما هو متوسط وقت التسليم؟',
                    answer: 'عادةً يتم تسليم الطلبات المحلية في 2-5 أيام عمل، بينما تستغرق الطلبات الدولية 5-14 أيام عمل حسب الوجهة.'
                },
                {
                    category: 'المرتجعات والتبديلات',
                    question: 'كيف تعمل المرتجعات؟',
                    answer: 'نقوم بمعالجة المرتجعات باسمك! يرسل العملاء المرتجعات إلى مستودعنا، ونقوم بفحصها وتحديث مخزونك وفقًا لذلك.'
                },
                {
                    category: 'المرتجعات والتبديلات',
                    question: 'هل يمكنك التعامل مع التبديلات؟',
                    answer: 'نعم، يمكننا إدارة عملية التبديل بالكامل، بما في ذلك الفحص وإعادة التزويد وإرسال منتجات استبدال لعملائك.'
                },
                {
                    category: 'المرتجعات والتبديلات',
                    question: 'ما هو وقت معالجة المرتجعات؟',
                    answer: 'عادةً تتم معالجة المرتجعات في غضون 24-48 ساعة من الاستلام، ويتم تحديث مخزونك فورًا في نظامنا.'
                },
                {
                    category: 'الحلول المخصصة',
                    question: 'هل يمكنك التعامل مع تغليف مخصص؟',
                    answer: 'بالتأكيد! نقدم تغليف مخصص، إدراجات علامة تجارية، تغليف هدايا وخدمات عرض خاصة لرفع مستوى علامتك التجارية.'
                },
                {
                    category: 'الحلول المخصصة',
                    question: 'هل تدعم التركيب والتجميع؟',
                    answer: 'نعم! نقدم خدمات التركيب والتجميع والتعبئة والتخصيص للمنتجات لخلق مزيجات منتجات فريدة.'
                },
                {
                    category: 'الحلول المخصصة',
                    question: 'هل يمكنك التكامل مع منصتي؟',
                    answer: 'نقوم بالتكامل مع جميع منصات التجارة الإلكترونية الرئيسية، بما في ذلك Shopify، WooCommerce، BigCommerce، Magento وغيرها. اتصل بنا حول التكاملات المخصصة!'
                }
            ]
        },
        footer: {
            about: 'من نحن',
            company: 'ملف الشركة',
            team: 'أعضاء الفريق',
            news: 'الأخبار',
            careers: 'الوظائف',
            solutions: 'الحلول',
            dropshipping: 'دروب شيبينغ',
            fulfillment: 'الاستيفاء',
            logistics: 'اللوجستية',
            custom: 'الحلول المخصصة',
            support: 'الدعم',
            help: 'مركز المساعدة',
            faq: 'الأسئلة الشائعة',
            contact: 'اتصل بنا',
            privacy: 'سياسة الخصوصية',
            contactInfo: 'معلومات الاتصال',
            email: 'البريد الإلكتروني: 270302301@qq.com',
            phone: 'الهاتف: +86 18905051115',
            whatsapp: 'واتساب: 0086 18905051115',
            copyright: '© 2026 منصة FULFILLDROP للتجارة الإلكترونية العابرة للحدود. جميع الحقوق محفوظة.'
        }
    }
};